import _ from 'root/libs/exaforte/react/lodash';
import React from 'react';
import { Image, View } from 'react-native';
import Components from 'root/Components';
import Config from 'root/globals/Config';
import styles from './Functions.less';
import CustomDate from 'root/libs/exaforte/react/CustomDate';
import Model from 'root/libs/exaforte/react/Model';
import { BlueprintBlockPlanningModel, RoutePlanningModel } from './planning/PlanningModel';
import { BlueprintBlockModel, BlueprintBlockSettingModel, RouteModel, RouteSettingModel, PlanningUserAvailabilityScheduleFreeModel } from './planning/PlannableModel';
import getMomentObject from 'root/globals/Moment Cache';
import moment from 'moment';

const year_week_cache = {};

export function openUserPage(settings) {
    const { pages = null, user = null, params = null, tabs = null } = settings;
    let url                                                         = null;
    
    switch(parseInt(user.component_id))
    {
        case Components.__EMPLOYEE_COMPONENT__:                 url = pages.employee + '#/view/' + user.id + '/' + (tabs ? '?tab_id=' + tabs.employee : ''); break;
        case Components.__SUBCONTRACTOR_COMPONENT__:            url = pages.subcontractor + '#/view/' + user.id + '/' + (tabs ? '?tab_id=' + tabs.subcontractor : ''); break;
        case Components.__SUBCONTRACTOR_EMPLOYEE_COMPONENT__:   url = pages.subcontractor + '#/view/' + user.subcontractor_id + '/employeeview/' + user.id + '/' + (tabs ? '?tab_id=' + tabs.subcontractorEmployee : ''); break;
    }

    if(url)
        window.open(url + (params ? _.set_url_params('', params) : ''), '_blank').focus();
}

export function getUserPicture(user, size) {
    if(user.component_id == Components.__CUSTOMER_COMPONENT__ || user.component_id == Components.__CUSTOMER_OBJECT_COMPONENT__ || user.component_id == Components.__CUSTOMER_OBJECT_COMPONENT__)
        return getLogo(user, size);

    if(user.component_id == Components.__SUBCONTRACTOR_COMPONENT__ || user.component_id == Components.__SUBCONTRACTOR_EMPLOYEE_COMPONENT__)
        return getSubcontractorLogo(user, size);
    
    return getAvatar(user, size);
}

export function getAvatar(employee, size) {
    if(employee.avatar)
    {
        let source = null;
        
        if(employee.component_id == Components.__JOB_APPLICATION_COMPONENT__)
            source = Config.IMAGES_URL + 'image-' + employee.component_id + '-' + employee.id + '.jpg';
        else
            source = Config.IMAGES_URL + 'file-' + Components.__EMPLOYEE_COMPONENT__ + '-' + employee.id + '-avatar-thumbnail.png';
        
        return <Image source={source} className={[styles['avatar-icon'], ...(size ? [styles[size]] : [])]} />;
    }
    
    return <View className={[styles['avatar-icon'], ...(size ? [styles[size]] : [])]}>{(employee.firstname ? employee.firstname[0] + (employee.lastname ? employee.lastname[0] : employee.firstname[1]) : employee.title[0] + employee.title[1])}</View>;
}

export function getSubcontractorLogo(subcontractor, size) {
    if(subcontractor.avatar || subcontractor.logo)
        return <Image source={Config.IMAGES_URL + 'file-' + subcontractor.component_id + '-' + subcontractor.id + '-' + (subcontractor.logo ? 'logo' : 'avatar') + '-thumbnail.png'} className={[styles['avatar-icon'], ...(size ? [styles[size]] : [])]} />;
    
    let label = subcontractor.display_name || subcontractor.title;
    
    return <View className={[styles['avatar-icon'], ...(size ? [styles[size]] : [])]}>{label[0] + label[1]}</View>;
}

export function getLogo(company, size) {
    if(company.logo)
        return <Image source={Config.IMAGES_URL + 'file-' + company.component_id + '-' + company.id + '-logo-thumbnail.png'} className={[styles['avatar-icon'], ...(size ? [styles[size]] : [])]} />;

    return <View className={[styles['avatar-icon'], ...(size ? [styles[size]] : [])]}>{company.title[0] + company.title[1]}</View>;
}

export function getDateBlocks(settings) {
    settings        = { skip_zero_minutes: true, ...settings };
    let response    = { pause: 0, dates: {} };
    
    if(!settings.start_date_time)
        settings.start_date_time = settings.date + ' ' + settings.start_time;
    
    if(!settings.end_date_time)
        settings.end_date_time = (settings.start_time > settings.end_time ? moment(settings.date).add({ days: 1 }).format('YYYY-MM-DD') : settings.date) + ' ' + settings.end_time;
    
    let time_blocks = { [settings.start_date_time]: 'shift', [settings.end_date_time]: 'shift' };
    
	// Pauze tijd van deze dienst bepalen
	if(!_.is_empty(settings.pauses))
	    for(let i in settings.pauses)
	    {
	        let pause_item = settings.pauses[i];
	        
	        if(_.is_empty(pause_item.start_time) || _.is_empty(pause_item.end_time))
	            continue;
            
            let shift_start_time    = _.get_time_format(settings.start_date_time);
            let shift_end_time      = _.get_time_format(settings.end_date_time);
            let pause_start_time    = _.get_time_format(pause_item.start_time);
            let pause_end_time      = _.get_time_format(pause_item.end_time);
            
            if(pause_start_time > shift_start_time)
                pause_item.start_date_time = _.get_date_format(settings.start_date_time, true) + ' ' + pause_start_time + ':00';
            else if(pause_start_time <= shift_end_time)
                pause_item.start_date_time = _.get_date_format(settings.end_date_time, true) + ' ' + pause_start_time + ':00';
            else
                continue;
            
            if(pause_end_time > shift_start_time)
                pause_item.end_date_time = _.get_date_format(settings.start_date_time, true) + ' ' + pause_end_time + ':00';
            else if(pause_end_time == '00:00' || pause_end_time <= shift_end_time)
                pause_item.end_date_time = _.get_date_format(settings.end_date_time, true) + ' ' + pause_end_time + ':00';
            else
                continue;
            
            // Als de pauze buiten de dienst valt tellen we hem niet mee.
            if(!_.is_crossing_datetime_period(settings.start_date_time, settings.end_date_time, pause_item.start_date_time, pause_item.end_date_time))
                continue;
            
            if(pause_item.start_date_time < settings.start_date_time)
                pause_item.start_date_time = settings.start_date_time;
            
            if(pause_item.end_date_time > settings.end_date_time)
                pause_item.end_date_time = settings.end_date_time;
            
            response.pause                          += (CustomDate.getCustomDateTime(pause_item.end_date_time) - CustomDate.getCustomDateTime(pause_item.start_date_time)) / 1000 / 60;
            time_blocks[pause_item.start_date_time] = 'pause';
            time_blocks[pause_item.end_date_time]   = 'shift';
	    }
    
    if(_.size(time_blocks) == 1 && !settings.skip_zero_minutes)
    {
        let date_time                                       = _.keys(time_blocks)[0];
        response.dates[_.get_date_format(date_time, true)]  = [{ start_time: _.get_time_format(date_time), end_time: _.get_time_format(date_time), type: time_blocks[date_time] }];
        
        return response;
    }
    
    time_blocks     = _.ksort(time_blocks);
    let date_times  = _.keys(time_blocks);
    let i           = 1;
    
    for(let date_time in time_blocks)
    {
        if(_.is_empty(date_times[i]))
            break;
        
        let type        = time_blocks[date_time];
        let start_date  = _.get_date_format(date_time, true);
        let end_date    = _.get_date_format(date_times[i], true);
        
        _.set_object_chain(response.dates, { chain: [start_date], value: [] });
        
        if(type == 'shift' && !_.is_empty(settings.max_minutes) && settings.current_minutes > settings.max_minutes)
            type = 'overtime';
        
        if(start_date != end_date)
        {
            if(!_.is_empty(settings.max_minutes) && type == 'shift')
            {
                let minutes = (CustomDate.getCustomDateTime(_.get_date_format(date_time, true) + ' 24:00:00') - CustomDate.getCustomDateTime(date_time)) / 1000 / 60;
                
                if(minutes + settings.current_minutes > settings.max_minutes)
                {
                    let end_date_time = moment(date_time).add({ minutes: settings.max_minutes - settings.current_minutes }).format('YYYY-MM-DD HH:mm:ss');
                    
                    response.dates[start_date].push({ start_time: _.get_time_format(date_time) + ':00', end_time: _.get_time_format(end_date_time) + ':00', type });
                    
                    date_time   = end_date_time;
                    type        = 'overtime';
                }
                
                settings.current_minutes += minutes;
            }
            
            response.dates[start_date].push({ start_time: _.get_time_format(date_time) + ':00', end_time: '24:00:00', type });
            
            date_time = end_date + ' 00:00:00';
            
            if(!_.is_empty(settings.max_minutes) && type == 'shift')
            {
                let minutes = (CustomDate.getCustomDateTime(date_times[i]) - CustomDate.getCustomDateTime(_.get_date_format(date_times[i], true) + ' 00:00:00')) / 1000 / 60;
                
                if(minutes + settings.current_minutes > settings.max_minutes)
                {
                    let end_date_time = moment(date_time).add({ minutes: settings.max_minutes - settings.current_minutes }).format('YYYY-MM-DD HH:mm:ss');
                    
                    _.set_object_chain(response.dates, { chain: [end_date], value: [] });
                    response.dates[end_date].push({ start_time: '00:00:00', end_time: _.get_time_format(end_date_time) + ':00', type });
                    
                    date_time   = end_date_time;
                    type        = 'overtime';
                }
                
                settings.current_minutes += minutes;
            }
            
            if(_.get_time_format(date_time) != _.get_time_format(date_times[i]))
            {
                _.set_object_chain(response.dates, { chain: [end_date], value: [] });
                response.dates[end_date].push({ start_time: _.get_time_format(date_time) + ':00', end_time: _.get_time_format(date_times[i]) + ':00', type });
            }
        }
        else if(_.get_time_format(date_time) != _.get_time_format(date_times[i]))
        {
            if(!_.is_empty(settings.max_minutes) && type == 'shift')
            {
                let minutes = (CustomDate.getCustomDateTime(date_times[i]) - CustomDate.getCustomDateTime(date_time)) / 1000 / 60;
                
                if(minutes + settings.current_minutes > settings.max_minutes)
                {
                    let end_date_time = moment(date_time).add({ minutes: settings.max_minutes - settings.current_minutes }).format('YYYY-MM-DD HH:mm:ss');
                    
                    response.dates[start_date].push({ start_time: _.get_time_format(date_time) + ':00', end_time: _.get_time_format(end_date_time) + ':00', type });
                    
                    date_time   = end_date_time;
                    type        = 'overtime';
                }
                
                settings.current_minutes += minutes;
            }
            
            response.dates[start_date].push({ start_time: _.get_time_format(date_time) + ':00', end_time: _.get_time_format(date_times[i]) + ':00', type });
        }
        
        i++;
    }
    
    return response;
}

export function getSupplementRates(settings) {
    if(!settings.rate || !settings.dates || !settings.supplement_profiles || !settings.supplement_profile_items)
        return null;
    
    let response = [];
    
    for(let date in settings.dates)
    {
        let day_of_week = new CustomDate(date).getDayNumber();
        
        for(let i in settings.dates[date])
        {
            if(settings.dates[date][i].type == 'pause')
                continue;
            
            let time_block      = settings.dates[date][i];
            let start_date_time = date + ' ' + time_block.start_time;
            let end_date_time   = date + ' ' + time_block.end_time;
            let start_time      = time_block.start_time;
            let end_time        = time_block.end_time;
            
            for(let j in settings.supplement_profiles)
            {
                if(!settings.supplement_profile_items[settings.supplement_profiles[j]])
                    continue;
                
                for(let k in settings.supplement_profile_items[settings.supplement_profiles[j]])
                {
                    let supplement_profile_item = settings.supplement_profile_items[settings.supplement_profiles[j]][k];
                    
                    if(supplement_profile_item.structure_id == 10053 && date != supplement_profile_item.date)
                        continue;
                    
                    if(supplement_profile_item.structure_id == 10049 && day_of_week != supplement_profile_item.day)
                        continue;
                    
                    if((start_time >= supplement_profile_item.start_time && start_time < supplement_profile_item.end_time) || (end_time > supplement_profile_item.start_time && end_time <= supplement_profile_item.end_time) || (start_time < supplement_profile_item.start_time && end_time > supplement_profile_item.end_time))
                    {
                        let supplement_start_time   = supplement_profile_item.start_time;
                        let supplement_end_time     = supplement_profile_item.end_time;
                        
                        if(start_time > supplement_profile_item.start_time)
                            supplement_start_time = start_time;
                        
                        if(end_time < supplement_profile_item.end_time)
                            supplement_end_time = end_time;

                        let supplement_minutes = (CustomDate.getCustomDateTime(date + ' ' + supplement_end_time) - CustomDate.getCustomDateTime(date + ' ' + supplement_start_time)) / 1000 / 60;
                        
                        if(supplement_minutes == 0)
                            continue;
                        
                        let item = { minutes: supplement_minutes, type: supplement_profile_item.type, supplement_profile_item_id: supplement_profile_item.id };
                        
                        if(supplement_profile_item.type == 'Percentage')
                        {
                            item.rate       = settings.rate * (supplement_profile_item.supplement / 100)
                            item.percentage = supplement_profile_item.supplement;
                        }
                        else if(supplement_profile_item.type == 'Uurtarief')
                        {
                            item.rate       = supplement_profile_item.supplement;
                            item.percentage = 100;
                        }
                        
                        response.push(item);
                    }
                }
            }
        }
    }
    
    return response;
}

export function formatAddress(settings) {
    let address = '';
    
    if(!_.is_empty(settings.streetname))
        address += settings.streetname;
    
    if(!_.is_empty(settings.housenumber))
        address += (!_.is_empty(address) ? ' ' : '') + settings.housenumber + (_.if_empty(settings.housenumber_addition, ''));
    
    if(!_.is_empty(settings.zipcode))
        address += (!_.is_empty(address) ? ', ' : '') + settings.zipcode;
    
    if(!_.is_empty(settings.city))
        address += (!_.is_empty(address) ? (_.is_empty(settings.zipcode) ? ', ' : ' ') : '') + settings.city;
    
    return address;
}

export function calculateDeviatingTime(originalDateTime, deviatingTime, shiftDurationInMinutes) {
    const deviatedDateTime  = new CustomDate(_.get_date_format(originalDateTime, true) + ' ' + deviatingTime);
    const originalTime      = new CustomDate(originalDateTime);
    const diffInSeconds     = (deviatedDateTime.getTime() - originalTime.getTime()) / 1000;
    let differenceInMinutes = diffInSeconds / 60;

    if (Math.abs(differenceInMinutes) > shiftDurationInMinutes) {
        differenceInMinutes = differenceInMinutes < 0
            ? differenceInMinutes + (24*60)
            : differenceInMinutes - (24*60);
    }

    originalTime.setMinutes(originalTime.getMinutes() + differenceInMinutes);
    
    return originalTime.getDateTime(true);
}

export function applyDeviatingPayrollTime(planning_item, settings) {
    if(!_.is_empty(planning_item.start_date_time) && !_.is_empty(planning_item.end_date_time))
    {
        const minutes           = (new CustomDate(planning_item.end_date_time) - new CustomDate(planning_item.start_date_time))/60000;
        const newStartDateTime  = calculateDeviatingTime(planning_item.start_date_time, _.if_empty(settings.deviating_payroll_time.start_time, settings.start_time), minutes);
        const newEndDateTime    = new CustomDate(newStartDateTime);
    
        newEndDateTime.setMinutes(newEndDateTime.getMinutes() + _.time_to_minutes(_.if_empty(settings.deviating_payroll_time.duration, settings.duration)));
    
        planning_item.start_date_time   = newStartDateTime;
        planning_item.end_date_time     = newEndDateTime.getDateTime(true);
    }
    else
    {
        if(!_.is_empty(settings.deviating_payroll_time.start_time))
            settings.start_time = settings.deviating_payroll_time.start_time;
        
        if(!_.is_empty(settings.deviating_payroll_time.duration))
            settings.duration = settings.deviating_payroll_time.duration;
    }

    if(!_.is_empty(settings) && (!_.is_empty(settings.deviating_payroll_time.pause_start) || !_.is_empty(settings.deviating_payroll_time.pause_stop)))
    {
        if(_.is_empty(settings.pauses))
            settings.pauses = [{start_time: '', end_time: ''}];

        if(!_.is_empty(settings.deviating_payroll_time.pause_start))
            settings.pauses[0].start_time = settings.deviating_payroll_time.pause_start;

        if(!_.is_empty(settings.deviating_payroll_time.pause_start))
            settings.pauses[0].end_time = settings.deviating_payroll_time.pause_stop;
    }
}

export const Planning = {
    // Settings functions
    get_settings_data_for_date(settings) {
        settings = {exclude_fields: ['id', 'component_id', 'structure_id', 'fielddefine_id', 'start_date', 'end_date', 'removed'], ...settings};

        let data;

        if(!_.is_empty(settings.setting))
            data = _.cloneData(settings.setting);
        else if(!_.is_empty(settings.settings) && !_.is_empty(settings.date))
        {
            for(let i in settings.settings)
                if(settings.settings[i].start_date <= settings.date && (_.is_empty(settings.settings[i].end_date) || settings.settings[i].end_date >= settings.date))
                    data = _.cloneData(settings.settings[i]);
        }
        else if(!_.is_empty(settings.settings) && !_.is_empty(settings.year_week))
        {
            for(let i in settings.settings)
            {
                if(CustomDate.getFormat(settings.settings[i].start_date, 'getYearWeek') <= settings.year_week && (_.is_empty(settings.settings[i].end_date) || CustomDate.getFormat(settings.settings[i].end_date, 'getYearWeek') >= settings.year_week))
                    data = _.cloneData(settings.settings[i]);
            }
        }
        else if(!_.is_empty(settings.controller))
        {
            if(!_.is_empty(settings.parent_field_value) && !_.is_empty(settings.date))
                data = settings.controller.get_data_and_models({models: [settings.parent_component], after_combine_filter_field: {[settings.parent_field]: {value: settings.parent_field_value}, start_date: {value: settings.date, type: '<='}, end_date: {value: model => _.is_empty(model.end_date) || model.end_date >= settings.date, type: 'function'}, removed: {value: 't', type: 'excludes'}}, limit: 1});
            else if(!_.is_empty(settings.parent_field_value) && !_.is_empty(settings.year_week) && !_.is_empty(settings.controller))
                data = settings.controller.get_data_and_models({models: [settings.parent_component], after_combine_filter_field: {[settings.parent_field]: {value: settings.parent_field_value}, year_week: {value: model => {
                    return (CustomDate.getFormat(model.start_date, 'getYearWeek') <= settings.year_week && (_.is_empty(model.end_date) || CustomDate.getFormat(model.end_date, 'getYearWeek') >= settings.year_week));
                }, type: 'function'}, removed: {value: 't', type: 'excludes'}}, limit: 1});
        }

        if(_.is_empty(data))
            return null;

        let exception = null;

        if(!_.is_empty(settings.exception))
            exception = _.cloneData(settings.exception);
        else if(!_.is_empty(settings.exceptions) && !_.is_empty(settings.date))
        {
            if(settings.exceptions && settings.exceptions[settings.date])
                exception = _.cloneData(settings.exceptions[settings.date]);
        }
        else if(!_.is_empty(settings.exceptions) && !_.is_empty(settings.year_week))
        {
            for(let date in settings.exceptions)
            {
                if(CustomDate.getFormat(date, 'getYearWeek') == settings.year_week)
                    exception = _.cloneData(settings.exceptions[date]);
            }
        }
        else if(!_.is_empty(settings.controller) && !settings.skip_exceptions)
        {
            if(!_.is_empty(settings.date))
                exception = settings.controller.get_data({models: [settings.exception_component], filter_field: {[settings.parent_field]: {value: data[settings.parent_field]}, start_date: {value: settings.date}, removed: {value: 't', type: 'excludes'}}, limit: 1});
            else if(!_.is_empty(settings.year_week))
            {
                exception = settings.controller.get_data({models: [settings.exception_component], filter_field: {[settings.parent_field]: {value: data[settings.parent_field]}, year_week: { value: model => {
                    return CustomDate.getFormat(model.start_date, 'getYearWeek') == settings.year_week;
                }, type: 'function' }, removed: {value: 't', type: 'excludes'}}, limit: 1});
            }
        }
        
        if(!_.is_empty(exception))
        {
            // Deze hebben we nodig, anders moeten we overal weer loopen om erachter te komen of die een exception heeft
            data = {...data, ...{exception_id: exception.id, exception_date: exception.start_date}, ..._.mapValues(_.pickBy(exception, (value, key) => !_.is_empty(value) && !_.includes(settings.exclude_fields, key)), value => {
                    //$_EMPTY_PLACEHOLDER_$ (string) en -31121985 (int) is om waardes zoals task_ids of notification_check_id leeg te maken in een uitzondering. Anders zou die null zijn en dan skipt deze check de uitzondering.
                    if(value == '$_EMPTY_PLACEHOLDER_$' || value == -31121985)
                        value = null;

                    return value
                })};
        }
        
        return data;
    },
    // Blueprint block functions
    copy_blueprint_block(settings) {
        settings        = {component_id: Components.__PLANNING_BLUEPRINT_BLOCK_COMPONENT__, return_block_and_settings: false,...settings}
        let data        = _.cloneData(settings.data) || this.get_blueprint_block_data_for_date({controller: settings.controller, blueprint_block_id: settings.copy_id, date: settings.copy_date});
        let date        = new CustomDate(settings.date);
        data.day        = settings.day || date.getDayNumber();
        data.start_date = date.getYearMonthDay();
        
        if(settings.component_id == Components.__PLANNING_BLUEPRINT_BLOCK_COMPONENT__)
            data.end_date = date.getYearMonthDay();
        
        delete data.id;
        delete data.setting_id;
        delete data.setting_start_date;
        delete data.setting_end_date;
        delete data.exception_id;
        delete data.exception_date;
        delete data.component_id; // Mocht je van een exception kopieren, moet het wel gewoon een vaste worden
        delete data.structure_id; // Mocht je van een exception kopieren, moet het wel gewoon een vaste worden
        delete data.fielddefine_id; // Mocht je van een exception kopieren, moet het wel gewoon een vaste worden
        
        if(!_.is_empty(settings.settings_data))
            data = {...data, ...settings.settings_data};

        if(!_.is_empty(data.customer_contract_arrangement_id))
        {
            const customerContractArrangementAlternative = settings.controller.get_data({models: [Components.__CUSTOMER_CONTRACT_ARRANGEMENT_ALTERNATIVE_COMPONENT__], filter_field: {id: {value: data.customer_contract_arrangement_id}}, limit: 1});
            
            if(!_.is_empty(customerContractArrangementAlternative))
            {
                const customerContractArrangement = settings.controller.get_data({models: [Components.__CUSTOMER_CONTRACT_ARRANGEMENT_COMPONENT__], filter_field: {id: {value: customerContractArrangementAlternative.customer_contract_arrangement_id}}, limit: 1});
                
                if(customerContractArrangement.start_date > date.getYearMonthDay() || _.if_empty(customerContractArrangement.end_date, date.getYearMonthDay()) < date.getYearMonthDay())
                    delete data.customer_contract_arrangement_id; // arrangement is niet meer geldig
                else
                {
                    const customerContract = settings.controller.get_data({models: [Components.__CUSTOMER_CONTRACT_COMPONENT__], filter_field: {id: {value: customerContractArrangement.customer_contract_id}}, limit: 1});

                    if(customerContract.start_date > date.getYearMonthDay() || _.if_empty(customerContract.end_date, date.getYearMonthDay()) < date.getYearMonthDay())
                        delete data.customer_contract_arrangement_id; // contract is niet meer geldig
                }
            }
        }

        let blueprint_block_model           = new BlueprintBlockModel({controller: settings.controller, name: settings.component_id, data: _.pick(data, ['customer_id', 'customer_object_id', 'start_date', 'end_date', 'disable_sync'])});
        let blueprint_block_setting_model   = new BlueprintBlockSettingModel({controller: settings.controller, name: Components.__BLUEPRINT_BLOCK_SETTING_COMPONENT__, data: {...data, frequency: 1, blueprint_block_id: blueprint_block_model.get_field_data('id')}});

        blueprint_block_setting_model.commit_changes({reset_start_data: false, reset_changed_data: false}); // setting moet eerst want hierna volgt een state update die ervoor kan zorgen dat er een block bestaat zonder setting
        blueprint_block_model.commit_changes({reset_start_data: false, reset_changed_data: false});

        if(settings.return_block_and_settings)
            return {blueprint_block_model, blueprint_block_setting_model};

        return blueprint_block_model;
    },
    
    get_blueprint_block_data_for_date(settings) {
        settings    = {...{}, ...settings};
        let data    = null;

        if(_.is_empty(settings.date) && _.is_empty(settings.year_week))
            return null;

        if(settings.blueprint_block)
            data = _.cloneData(settings.blueprint_block);
        else if(!_.is_empty(settings.controller) && !_.is_empty(settings.blueprint_block_id))
            data = settings.controller.get_data_and_models({models: [Components.__BLUEPRINT_BLOCK_COMPONENT__, Components.__PLANNING_BLUEPRINT_BLOCK_COMPONENT__], after_combine_filter_field: {id: {value: settings.blueprint_block_id}, removed: {value: 't', type: 'excludes'}}, limit: 1});

        if(!data)
            console.log(settings);

        let setting = this.get_blueprint_block_setting_data_for_date({...settings, ...{blueprint_block_id: data.id}});

        if(_.is_empty(setting))
            return null;

        setting.setting_id          = setting.id;
        setting.setting_start_date  = setting.start_date;
        setting.setting_end_date    = setting.end_date;

        delete setting.id;
        delete setting.component_id;
        delete setting.structure_id;
        delete setting.fielddefine_id;
        delete setting.start_date;
        delete setting.end_date;

        return {...data, ...setting};
    },
    
    get_blueprint_block_setting_data_for_date(settings) {
        return this.get_settings_data_for_date({...settings, parent_field_value: settings.blueprint_block_id, parent_field: 'blueprint_block_id', parent_component: Components.__BLUEPRINT_BLOCK_SETTING_COMPONENT__, exception_component: Components.__BLUEPRINT_BLOCK_SETTING_EXCEPTION_COMPONENT__});
    },
    
    dummy(settings) {
        
    },
    
    is_blueprint_block_in_route_for_yearweek(settings) {
        settings        = {skip_exceptions: false, ...settings};
        const response  = { route_id: -1, is_exception: false };
        
        if(!_.is_empty(settings.controller))
        {
            if(_.is_empty(settings.blueprint_block) && !_.is_empty(settings.blueprint_block_id))
                settings.blueprint_block = Planning.get_blueprint_block_data_for_date({controller: settings.controller, blueprint_block_id: settings.blueprint_block_id, ...(!_.is_empty(settings.date) ? {date: settings.date} : {year_week: settings.year_week})});

            if(_.is_empty(settings.route_blueprint_blocks))
                settings.route_blueprint_blocks = settings.controller.get_data({models: (settings.skip_exceptions ? [Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_COMPONENT__] : [Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_COMPONENT__, Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_EXCEPTION_COMPONENT__]), filter_field: {blueprint_block_id: {value: settings.blueprint_block.id}, removed: {value: 't', type: 'excludes'}, yearweek: {type: 'function', value: model => _.is_empty(model.end_year_week) || model.start_year_week <= model.end_year_week}}, format: 'asGrouped', key: {'blueprint_block_id': {'component_id': 'start_year_week'}}});

            if(_.is_empty(settings.routes))
                settings.routes = settings.controller.get_data({models: [Components.__PLANNING_ROUTE_COMPONENT__, Components.__PLANNING_SINGLE_ROUTE_COMPONENT__], filter_field: {removed: {value: 't', type: 'excludes'}}, format: 'asGrouped', key: 'id'});
        
            if(settings.return_route_parent && _.is_empty(settings.route_parents))
                settings.route_parents = settings.controller.get_data({models: [Components.__ROUTE_PARENT_COMPONENT__], format: 'asGrouped', key: 'id'});
        }
        
        if(_.is_empty(settings.date) && !_.is_empty(settings.year_week))
            settings.date = moment(settings.year_week, 'GGGGWW').add(settings.blueprint_block.day, 'days').format('YYYY-MM-DD');

        // Let op: De yearweek die in __PLANNING_ROUTE_BLUEPRINT_BLOCK_COMPONENT__ staat is altijd gebaseerd op de route, dus het zorgblok kan een andere yearweek hebben dan de route. Daarom passen we de te checken yearweek in de onderstaande code aan wanneer de route niet overeenkomt met het zorgblok.
        if(!settings.route_blueprint_blocks[settings.blueprint_block.id])
            return response;

        let recurring_route_id = null;

        if(settings.route_blueprint_blocks[settings.blueprint_block.id][Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_COMPONENT__])
            for(let i in settings.route_blueprint_blocks[settings.blueprint_block.id][Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_COMPONENT__])
            {
                let year_week               = CustomDate.getFormat(settings.date, 'getYearWeek');
                let route_blueprint_block   = settings.route_blueprint_blocks[settings.blueprint_block.id][Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_COMPONENT__][i];

                // Als de dienst op een maandag valt moeten we kijken of hij niet in een route zit van de week ervoor op zondag. Dit alleen voor de maandag doen. Want een dienst moet altijd volledig in de route vallen en daarom hoeven we zondag diensten niet voor een maandag te bekijken. Want die kunnen nooit volledig in de route vallen.
                // Doen ook een check of de route nog bestaat, kan namelijk zijn dat hij in de week waarin we checken niet meer bestaat, omdat hij is afgekapt.
                if(settings.blueprint_block.day == 0 && settings.routes[route_blueprint_block.route_id] && settings.routes[route_blueprint_block.route_id].day == 6)
                    year_week = CustomDate.getFormat(settings.date, 'getLastWeekYearWeek');

                if(route_blueprint_block.start_year_week <= year_week && _.if_empty(route_blueprint_block.end_year_week, year_week) >= year_week)
                    recurring_route_id = route_blueprint_block.route_id;
            }

        if(!settings.skip_exceptions)
        {
            let exception_year_week = CustomDate.getFormat(settings.date, 'getYearWeek');//new CustomDate(settings.date);
            
            // Als er geen uitzonderingen zijn hoeven we ook niet verder te kijken
            if(settings.route_blueprint_blocks[settings.blueprint_block.id][Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_EXCEPTION_COMPONENT__])
            {
                // Als de dienst op een maandag valt moeten we kijken of hij niet in een route zit van de week ervoor op zondag. Dit alleen voor de maandag doen. Want een dienst moet altijd volledig in de route vallen en daarom hoeven we zondag diensten niet voor een maandag te bekijken. Want die kunnen nooit volledig in de route vallen.
                if(recurring_route_id != null && settings.blueprint_block.day == 0 && settings.routes[recurring_route_id].day != settings.blueprint_block.day)
                {
                    let blueprint_block_route_exceptions = settings.route_blueprint_blocks[settings.blueprint_block.id][Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_EXCEPTION_COMPONENT__];
                    
                    exception_year_week = CustomDate.getFormat(settings.date, 'get' + (settings.blueprint_block.day == 0 ? 'Last' : 'Next') + 'WeekYearWeek');//exception_year_week.setDate(exception_year_week.getDate() + (settings.blueprint_block.day == 0 ? -7 : 7));
                    
                    // Hij is niet eenmalig uit de route gehaald, dus kunnen we de exception datum weer terugzetten naar hoe die was. Anders hadden we op een maandag dienst bijv. in de route van de zondag van de week ervoor moeten kijken.
                    // Wanneer die in een andere route gezet is moeten we wel naar de datum kijken zoals we hem meekregen in de functie. Want dan is die yearweek leidend voor die route.
                    if(blueprint_block_route_exceptions[exception_year_week] && blueprint_block_route_exceptions[exception_year_week].route_id != -1)
                        exception_year_week = CustomDate.getFormat(settings.date, 'getYearWeek');//exception_year_week.setDate(exception_year_week.getDate() + (settings.blueprint_block.day == 0 ? 7 : -7));
                    // Hij is wel eenmalig uit de route gehaald, maar ook weer eenmalig in de route van de week van de dienst gezet.
                    else if(blueprint_block_route_exceptions[settings.date.getYearWeek()] && blueprint_block_route_exceptions[settings.date.getYearWeek()].route_id != -1)
                    {
                        // Als de eenmalige wijziging voor deze week op dezelfde dag valt als de dienst, moeten we hem ook in deze week laten kijken.
                        if(settings.blueprint_block.day == settings.routes[blueprint_block_route_exceptions[settings.date.getYearWeek()].route_id].day)
                            exception_year_week = CustomDate.getFormat(settings.date, 'getYearWeek');//exception_year_week.setDate(exception_year_week.getDate() + (settings.blueprint_block.day == 0 ? 7 : -7));
                    }
                }
                else if(recurring_route_id == null && settings.blueprint_block.day == 0)
                {
                    let blueprint_block_route_exceptions = settings.route_blueprint_blocks[settings.blueprint_block.id][Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_EXCEPTION_COMPONENT__];
                    
                    exception_year_week = CustomDate.getFormat(settings.date, 'getLastWeekYearWeek'); //exception_year_week.setDate(exception_year_week.getDate() - 7);

                    // Als er een uitzondering is en de route valt op zondag terwijl de dag van de dienst op maandag valt moeten we een week terugkijken, de week van de route dus. Hier zetten we hem terug als hij niet op zondag valt
                    if(!blueprint_block_route_exceptions[exception_year_week] || blueprint_block_route_exceptions[exception_year_week].route_id == -1 || (settings.routes[blueprint_block_route_exceptions[exception_year_week].route_id] && settings.routes[blueprint_block_route_exceptions[exception_year_week].route_id].day != 6))
                        exception_year_week = CustomDate.getFormat(settings.date, 'getYearWeek'); //exception_year_week.setDate(exception_year_week.getDate() + 7);
                }
            }

            if(settings.route_blueprint_blocks[settings.blueprint_block.id][Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_EXCEPTION_COMPONENT__] && settings.route_blueprint_blocks[settings.blueprint_block.id][Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_EXCEPTION_COMPONENT__][exception_year_week])
            {
                response.route_id       = settings.route_blueprint_blocks[settings.blueprint_block.id][Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_EXCEPTION_COMPONENT__][exception_year_week].route_id;
                response.is_exception   = true;
            }
        }
        
        if(!response.is_exception && recurring_route_id !== null)
            response.route_id = recurring_route_id;
        
        if(response.route_id > -1 && !_.is_empty(settings.route_parents) && settings.routes[response.route_id] && settings.route_parents[settings.routes[response.route_id].route_parent_id])
            response.route_parent = settings.route_parents[settings.routes[response.route_id].route_parent_id];
        
        return response;
    },
    
    // TODO: kijken of we deze functie kunnen optimaliseren door de CustomDate te cachen zodat hij niet telkens opnieuw aangemaakt hoeft te worden.
    get_blueprint_block_date_time_for_route(settings) {
        let start_date_time;
        let route_start_date;
        let route_end_date;
        let route_start_day_nr;
        let route_end_day_nr;

        // Als er geen start_date_time en end_date_time gaan we zelf achter die tijd proberen te komen door de instellingen voor de route van die dag op te halen.
        if(_.is_empty(settings.route.start_date_time) && settings.route.date)
        {
            let route_settings      = this.get_route_data_for_date({route: settings.route, date: settings.route.date, controller: settings.controller});
            route_start_date        = settings.route.date;
            route_start_day_nr      = CustomDate.getFormat(settings.route.date, 'getDayNumber');
            route_end_date          = CustomDate.getCustomDateTime(settings.route.date + ' ' + route_settings.start_time);
            
            route_end_date.setMinutes(route_end_date.getMinutes() + _.time_to_minutes(route_settings.duration));
            route_end_date          = route_end_date.getDateTime(true);
        }
        else
        {
            route_start_date    = _.get_date_format(settings.route.start_date_time, true);
            route_start_day_nr  = CustomDate.getFormat(route_start_date, 'getDayNumber');
            route_end_date      = _.get_date_format(settings.route.end_date_time, true);
            route_end_day_nr    = CustomDate.getFormat(route_end_date, 'getDayNumber');
        }

        if(route_start_day_nr == settings.blueprint_block.day)
            start_date_time = route_start_date + ' ' + settings.blueprint_block.start_time;
        else if(route_end_day_nr == settings.blueprint_block.day)
            start_date_time = route_end_date + ' ' + settings.blueprint_block.start_time;
        else
            // LET OP: dienst valt niet meer binnen de route. Daarom berekenen we het gewoon als een dag later. Vroeger is namelijk niet mogelijk, maar je kunt een dienst wel korter maken waardoor hij niet meer over 2 dagen valt.
            start_date_time = CustomDate.getFormat(route_start_date, 'getTomorrowYearMonthDay') + ' ' + settings.blueprint_block.start_time;

        let end_date_time = CustomDate.getCustomDateTime(start_date_time);
        
        end_date_time.setMinutes(end_date_time.getMinutes() + _.time_to_minutes(settings.blueprint_block.duration));
        
        return {start_date_time: start_date_time, end_date_time: end_date_time.getDateTime(true)};
    },
    
    // Route functions
    copy_route(settings) {
        settings                = {component_id: Components.__PLANNING_SINGLE_ROUTE_COMPONENT__,...settings}
        let data                = _.cloneData(settings.data) || this.get_route_settings_data_for_date({controller: settings.controller, route_id: settings.copy_id, date: settings.copy_date});
        let date                = new CustomDate(settings.date);
        let blueprint_blocks    = data.blueprint_blocks || this.get_route_blueprint_blocks_for_date({controller: settings.controller, route: {date: settings.copy_date, ...data}, date: settings.copy_date});
        data.day                = settings.day || date.getDayNumber();
        data.start_date         = date.getYearMonthDay();
        
        if(settings.component_id == Components.__PLANNING_SINGLE_ROUTE_COMPONENT__)
            data.end_date = date.getYearMonthDay();
        
        delete data.id;
        delete data.setting_id;
        delete data.setting_start_date;
        delete data.setting_end_date;
        delete data.exception_id;
        delete data.exception_date;
        delete data.component_id; // Mocht je van een exception kopieren, moet het wel gewoon een vaste worden
        delete data.structure_id; // Mocht je van een exception kopieren, moet het wel gewoon een vaste worden
        delete data.fielddefine_id; // Mocht je van een exception kopieren, moet het wel gewoon een vaste worden
        delete data.blueprint_blocks;

        if(!_.is_empty(settings.settings_data))
            data = {...data, ...settings.settings_data};

        let route_model           = new RouteModel({controller: settings.controller, name: settings.component_id, data: _.pick(data, ['route_parent_id', 'day', 'start_date', 'end_date', 'function_group_id'])});
        let route_setting_model   = new RouteSettingModel({controller: settings.controller, name: Components.__PLANNING_ROUTE_SETTING_COMPONENT__, data: {...data, route_id: route_model.get_field_data('id')}});

        route_setting_model.commit_changes({reset_start_data: false, reset_changed_data: false}); // setting moet eerst want hierna volgt een state update die ervoor kan zorgen dat er een route bestaat zonder setting
        route_model.commit_changes({reset_start_data: false, reset_changed_data: false});

        // route_blueprint_blocks ook kopieren
        for(let i in blueprint_blocks)
        {
            let date = _.cloneData(settings.date);

            if(blueprint_blocks[i].date != settings.copy_date)
                date = moment(date).add(1, 'day').format('YYYY-MM-DD');

            // Moeten de user_amount op 1 zetten, anders krijg je ineens open diensten te zien
            // Pauzes moeten niet mee gekopieerd worden.
            let blueprint_block_model = this.copy_blueprint_block({controller: settings.controller, data: {...blueprint_blocks[i], date: date, user_amount: 1, pauses: null}, date: date});
            
            this.add_blueprint_block_to_route({controller: settings.controller, date: route_model.get_field_data('start_date'), blueprint_block_id: blueprint_block_model.get_field_data('id'), route_id: route_model.get_field_data('id'), exception: true});
        }

        return route_model;
    },

    get_route_data_for_date(settings) {
        settings = {skip_exceptions: false, include_datetime_period: false, ...settings};
        let data = null;

        if(!_.is_empty(settings.controller) && !_.is_empty(settings.route_id))
            data = settings.controller.get_data_and_models({models: [Components.__PLANNING_ROUTE_COMPONENT__, Components.__PLANNING_SINGLE_ROUTE_COMPONENT__], after_combine_filter_field: {id: {value: settings.route_id}, removed: {value: 't', type: 'excludes'}}, limit: 1});
        else if(settings.route)
            data = _.cloneData(settings.route);

        let setting = this.get_route_settings_data_for_date({...settings, ...{route_id: data.id}});

        if(_.is_empty(setting))
            return null;
        
        if(data.route_parent_id)
        {
            if(settings.route_parents)
                data.title = settings.route_parents[data.route_parent_id].title;
            else if(!_.is_empty(settings.controller))
            {
                let route_parent = settings.controller.get_data({ models: [Components.__ROUTE_PARENT_COMPONENT__], filter_field: { id: { value: data.route_parent_id } }, limit: 1 });
                
                if(route_parent)
                    data.title = route_parent.title;
            }
        }
        
        setting.setting_id          = setting.id;
        setting.setting_start_date  = setting.start_date;
        setting.setting_end_date    = setting.end_date;

        delete setting.id;
        delete setting.component_id;
        delete setting.structure_id;
        delete setting.fielddefine_id;
        delete setting.start_date;
        delete setting.end_date;
        delete setting.title;
        
        data = {...data, ...setting};
        
        if(settings.include_datetime_period)
        {
            data.start_date_time    = moment((settings.date ? settings.date : moment(settings.year_week.toString().substring(0, 4) + 'W' + settings.year_week.toString().substring(4))).format('YYYY-MM-DD') + ' ' + data.start_time).weekday(0).add(data.day, 'days').format('YYYY-MM-DD HH:mm');
            data.end_date_time      = moment(data.start_date_time).add(_.time_to_minutes(data.duration), 'minutes').format('YYYY-MM-DD HH:mm');
        }

        return data;
    },
    
    get_route_settings_data_for_date(settings) {
        return this.get_settings_data_for_date({...settings, parent_field_value: settings.route_id, parent_field: 'route_id', parent_component: Components.__PLANNING_ROUTE_SETTING_COMPONENT__, exception_component: Components.__PLANNING_ROUTE_SETTING_EXCEPTION_COMPONENT__});
    },
    
    get_route_random_shift_data_for_date(settings) {
        settings = { skip_exceptions: false, ...settings };
        let data = null;

        if(!_.is_empty(settings.route_random_shift_id) && !_.is_empty(settings.controller))
            data = settings.controller.get_data_and_models({ models: [Components.__PLANNING_ROUTE_RANDOM_SHIFT_COMPONENT__], after_combine_filter_field: { id: { value: settings.route_random_shift_id }, removed: { value: 't', type: 'excludes' } }, limit: 1 });
        else if(settings.route)
            data = _.cloneData(settings.route);

        let setting = this.get_route_random_shift_settings_data_for_date({ ...settings, ...{ planning_route_random_shift_id: data.id } });

        if(_.is_empty(setting))
            return null;
        
        setting.setting_id          = setting.id;
        setting.setting_start_date  = setting.start_date;
        setting.setting_end_date    = setting.end_date;
        
        delete setting.id;
        delete setting.component_id;
        delete setting.structure_id;
        delete setting.fielddefine_id;
        delete setting.start_date;
        delete setting.end_date;
        
        data = { ...data, ...setting };
        
        return data;
    },
    
    get_route_random_shift_settings_data_for_date(settings) {
        return this.get_settings_data_for_date({ ...settings, parent_field_value: settings.planning_route_random_shift_id, parent_field: 'planning_route_random_shift_id', parent_component: Components.__PLANNING_ROUTE_RANDOM_SHIFT_SETTING_COMPONENT__, skip_exceptions: true });
    },
    
    // TODO: Zo aanpassen dat de year_week_route_blueprint_blocks gesplitst zijn net zoals is_blueprint_block_in_route_for_yearweek
    get_route_blueprint_blocks_for_date(settings) {
        settings                            = {skip_exceptions: false, ...settings};
        let blueprint_blocks                = settings.blueprint_blocks;
        let random_shifts                   = settings.random_shifts;
        let planning_route_blueprint_blocks = settings.year_week_route_blueprint_blocks;
        let date                            = settings.date.getYearMonthDay();
        let yearweek                        = settings.date.getYearWeek();
        let route_start_time                = (settings.route && settings.route.start_time) ? settings.route.start_time : settings.date.getTimeText();
        let tomorrow                        = CustomDate.getFormat(date, 'getTomorrowYearMonthDay');

        // Route blocks ophalen en sorteren by component_id desc zodat de uitzonderingen eerst meekomen. Zo filter je de normale items van de uitzonderingen.
        if(!settings.year_week_route_blueprint_blocks)
        {
            let models = [Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_COMPONENT__];

            if(!settings.skip_exceptions)
                models.push(Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_EXCEPTION_COMPONENT__);

            planning_route_blueprint_blocks = settings.controller.get_data({models: models, filter_field: {year_week: {value: model => (yearweek >= model.start_year_week && yearweek <= _.if_empty(model.end_year_week, yearweek))}, removed: {value: 't', type: 'excludes'}}, format: 'asGrouped', key: ['blueprint_block_id'], sort: [{field: 'component_id', by: 'desc'}]});
        }

        if(!blueprint_blocks)
            blueprint_blocks = settings.controller.get_data({models: [Components.__PLANNING_BLUEPRINT_BLOCK_COMPONENT__, Components.__BLUEPRINT_BLOCK_COMPONENT__], filter_field: {id: {value: _.keys(planning_route_blueprint_blocks), type: 'includes_desc'}}, format: 'asGrouped', key: 'id'});
        
        let route_blueprint_block_ids = _.filter(planning_route_blueprint_blocks, model => model.route_id == settings.route.id);

        if(!settings.blueprint_block_settings)
            settings.blueprint_block_settings = settings.controller.get_data({models: [Components.__BLUEPRINT_BLOCK_SETTING_COMPONENT__], filter_field: {removed: {value: 't', type: 'excludes'}}, format: 'asGrouped', key: {'blueprint_block_id': '$auto_increment$'}});
        
        if(!settings.blueprint_block_setting_exceptions)
            settings.blueprint_block_setting_exceptions = settings.controller.get_data({models: [Components.__BLUEPRINT_BLOCK_SETTING_EXCEPTION_COMPONENT__], filter_field: {removed: {value: 't', type: 'excludes'}}, format: 'asGrouped', key: { blueprint_block_id: 'start_date' }});
        
        if(!random_shifts && settings.include_random_shifts)
            random_shifts = settings.controller.get_data({ models: [Components.__PLANNING_ROUTE_RANDOM_SHIFT_COMPONENT__], filter_field: { route_id: { value: _.format_input(settings.route.id) }, removed: { value: 't', type: 'excludes' } } });
        
        if(!_.is_empty(random_shifts))
        {
            if(!settings.random_shift_settings)
                settings.random_shift_settings = settings.controller.get_data({ models: [Components.__PLANNING_ROUTE_RANDOM_SHIFT_SETTING_COMPONENT__], filter_field: { removed: { value: 't', type: 'excludes' } }, format: 'asGrouped', key: { planning_route_random_shift_id: '$auto_increment$' } });
        }
        
        let route_blueprint_blocks  = [];

        for(let i in route_blueprint_block_ids)
        {
            if(!settings.blueprint_block_settings[route_blueprint_block_ids[i].blueprint_block_id])
                continue;

            let blueprint_block_setting = _.find(settings.blueprint_block_settings[route_blueprint_block_ids[i].blueprint_block_id], blueprint_block_setting => blueprint_block_setting.start_date <= date && (_.is_empty(blueprint_block_setting.end_date) || blueprint_block_setting.end_date >= date));
            let block_date              = date;

            if(!blueprint_block_setting || blueprint_block_setting.day == CustomDate.getFormat(date, 'getTomorrowDayNumber'))
            {
                // Diensten die op de volgende dag vallen komen hier anders niet in terug.
                blueprint_block_setting = _.find(settings.blueprint_block_settings[route_blueprint_block_ids[i].blueprint_block_id], blueprint_block_setting => blueprint_block_setting.start_date <= tomorrow && (_.is_empty(blueprint_block_setting.end_date) || blueprint_block_setting.end_date >= tomorrow));
                block_date              = tomorrow;
                
                if(!blueprint_block_setting)
                    continue;
            }

            let blueprint_block_date    = (!settings.route.day || blueprint_block_setting.day != settings.route.day ? tomorrow : settings.date.getYearMonthDay()); // Dit omdat we bij de get_blueprint_block_data_for_date functie wel de goede datum moeten meegeven vanwege de uitzondering die gemaakt kan worden. Die wordt dan niet gedaan op de datum wanneer de route start, maar de datum wanneer de dienst in de route start.
            let blueprint_block         = (settings.formatted_blueprint_blocks && _.has_object_chain(settings.formatted_blueprint_blocks, {chain: [CustomDate.getFormat(block_date, 'getYearWeek'), 'blocks', route_blueprint_block_ids[i].blueprint_block_id]}) ? settings.formatted_blueprint_blocks[CustomDate.getFormat(block_date, 'getYearWeek')]['blocks'][route_blueprint_block_ids[i].blueprint_block_id] : this.get_blueprint_block_data_for_date({blueprint_block: blueprint_blocks[route_blueprint_block_ids[i].blueprint_block_id], setting: blueprint_block_setting, date: blueprint_block_date, exceptions: settings.blueprint_block_setting_exceptions[route_blueprint_block_ids[i].blueprint_block_id]}));
            let item_date_time          = this.get_blueprint_block_date_time_for_route({route: settings.route, blueprint_block: blueprint_block, controller: settings.controller});
            let route_blueprint_block   = {...blueprint_block, ...item_date_time, date: _.get_date_format(item_date_time.start_date_time, true), is_exception: (route_blueprint_block_ids[i].component_id == Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_EXCEPTION_COMPONENT__), route_blueprint_block: route_blueprint_block_ids[i]};

            route_blueprint_blocks.push(route_blueprint_block);
        }

        for(let i in random_shifts)
        {
            let random_shift = random_shifts[i];
            
            if(!settings.random_shift_settings[random_shift.id])
                continue;
            
            if(random_shift.start_date > date || (!_.is_empty(random_shift.end_date) && random_shift.end_date < date))
                continue;
            
            let random_shift_settings = _.find(settings.random_shift_settings[random_shift.id], random_shift_setting => random_shift_setting.start_date <= date && (_.is_empty(random_shift_setting.end_date) || random_shift_setting.end_date >= date));
            
            if(!random_shift_settings)
                continue;

            let item_date_time = this.get_blueprint_block_date_time_for_route({route: settings.route, blueprint_block: random_shift_settings});
            
            route_blueprint_blocks.push({ ...random_shift_settings, ...random_shift, setting_id: random_shift_settings.id, date: _.get_date_format(item_date_time.start_date_time, true), start_date_time: item_date_time.start_date_time, end_date_time: item_date_time.end_date_time });
        }

        route_blueprint_blocks = _.sortBy(route_blueprint_blocks, 'start_date_time');

        return route_blueprint_blocks;
    },
    
    add_blueprint_block_to_route(settings) {
        settings = {exception: false, ...settings};
        
        if(settings.exception)
        {
            let date                            = new CustomDate(settings.date);
            let route_blueprint_block_exception = settings.controller.get_models_from_data({data: {models: [Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_EXCEPTION_COMPONENT__], filter_field: {blueprint_block_id: {value: settings.blueprint_block_id}, start_year_week: {value: date.getYearWeek()}, removed: {value: 't', type: 'excludes'}}}, models: {limit: 1}});

            if(!route_blueprint_block_exception)
                route_blueprint_block_exception = new Model({controller: settings.controller, name: Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_EXCEPTION_COMPONENT__, data: {route_id: settings.route_id, blueprint_block_id: settings.blueprint_block_id, start_year_week: date.getYearWeek(), end_year_week: date.getYearWeek()}});
            else
            {
                let current_route_for_blueprint_block = settings.controller.get_data({models: [Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_COMPONENT__], filter_field: {blueprint_block_id: {value: settings.blueprint_block_id}, period: {value: model => model.start_year_week <= date.getYearWeek() && (model.end_year_week == null || model.end_year_week >= date.getYearWeek()), type: 'function'}, removed: {value: 't', type: 'excludes'}}, limit: 1});
                
                // Stel je haalt een maandag dienst uit een zondag route en je zet hem daarna weer in een maandag route krijg je verschillende yearweeks voor dezelfde dienst
                if(settings.route_id == -1 && _.size(current_route_for_blueprint_block) > 0)
                {
                    let routes = settings.controller.get_data({models: [Components.__PLANNING_ROUTE_COMPONENT__, Components.__PLANNING_SINGLE_ROUTE_COMPONENT__], filter_field: {id: {value: [route_blueprint_block_exception.get_field_data('route_id'), current_route_for_blueprint_block.route_id], type: 'includes_desc'}}, format: 'asGrouped', key: ['id']});

                    // ALs de route dag niet hetzelfde is waardoor ze in verschillende weken vallen en de route dagen maandag of zondag zijn, dan mogen we hem verwijderen.
                    if(routes[route_blueprint_block_exception.get_field_data('route_id')].day != routes[current_route_for_blueprint_block.route_id].day && (routes[current_route_for_blueprint_block.route_id].day == 0 || routes[current_route_for_blueprint_block.route_id].day == 6) && (routes[route_blueprint_block_exception.get_field_data('route_id')].day == 0 || routes[route_blueprint_block_exception.get_field_data('route_id')].day == 6))
                        route_blueprint_block_exception.remove();
                    else
                        route_blueprint_block_exception.set_field_data({field: 'route_id', value: settings.route_id});
                }
                // Als we hem eenmalig terugzetten naar de vaste route dan kunnen we deze eenmalige route wel verwijderen. Heeft geen nut dan
                // Als er geen vaste route is kunnen we het item wel verwijderen, heeft geen nut om een -1 route_id te bewaren als uitzondering.
                else if((!_.is_empty(current_route_for_blueprint_block) && current_route_for_blueprint_block.route_id == settings.route_id) || settings.route_id == -1)
                    route_blueprint_block_exception.remove();
                else
                    route_blueprint_block_exception.set_field_data({field: 'route_id', value: settings.route_id});
            }

            route_blueprint_block_exception.commit_changes({reset_changed_data: false, reset_start_data: false});
        }
        else
        {
            let current_blueprint_routes    = settings.controller.get_models_from_data({data: {models: [Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_COMPONENT__, Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_EXCEPTION_COMPONENT__], filter_field: {blueprint_block_id: {value: settings.blueprint_block_id}}, sort: [{field: 'start_year_week'}]}, models: {return_models_split_components: false}});
            let start_date                  = new CustomDate(settings.date + ' 10:00:00');
            let last_week                   = new CustomDate(settings.date + ' 10:00:00');
            
            // Anders worden diensten uit de route gehaald die al afgerond zijn.
            if(!settings.disable_date_check && settings.date >= new CustomDate().getYearMonthDay())
                last_week.setDate(last_week.getDate() - 7);
    
            for(let i in current_blueprint_routes)
            {
                // Toekomstige instellingen worden allemaal ongedaan gemaakt
                if(current_blueprint_routes[i].get_field_data('start_year_week') >= start_date.getYearWeek())
                {
                    current_blueprint_routes[i].remove();
                    current_blueprint_routes[i].commit_changes({reset_changed_data: false, reset_start_data: false});
                }
                else if(_.if_empty(current_blueprint_routes[i].get_field_data('end_year_week'), start_date.getYearWeek()) >= start_date.getYearWeek())
                {
                     // Lopende instellingen moeten worden afgekapt op vorige getYearWeek, zodat de nieuwe het vanaf deze week oppakt
                    current_blueprint_routes[i].set_field_data({field: 'end_year_week', value: last_week.getYearWeek()});
                    current_blueprint_routes[i].commit_changes({reset_changed_data: false, reset_start_data: false});
                }
            }
            
            if(settings.route_id != -1)
            {
                let route           = settings.controller.get_data({models: [Components.__PLANNING_ROUTE_COMPONENT__, Components.__PLANNING_SINGLE_ROUTE_COMPONENT__], filter_field: {id: {value: settings.route_id}}, limit: 1});
                let blueprint_block = settings.controller.get_data({models: [Components.__BLUEPRINT_BLOCK_COMPONENT__, Components.__PLANNING_BLUEPRINT_BLOCK_COMPONENT__], filter_field: {id: {value: settings.blueprint_block_id}}, limit: 1});
                let prev_year_week  = moment(settings.date).subtract(1, 'week').format('GGGGWW');
                let end_year_week   = null;
                
                // Wanneer je een dienst toevoeg aan een route die in de toekomst afgekapt wordt moeten deze records ook wel afgekapt worden. Anders lijkt het nog steeds of ze in een route staan.
                if(!_.is_empty(route.end_date))
                    end_year_week = moment(route.end_date).format('GGGGWW');
                
                // Als de dienst zelf in de toekomst al wordt afgekapt mag hij natuurlijk niet langer dan die datum in de route gezet worden.
                if(!_.is_empty(blueprint_block.end_date) && (_.is_empty(route.end_date) || route.end_date > blueprint_block.end_date))
                    end_year_week = moment(blueprint_block.end_date).format('GGGGWW');
    
                let route_blueprint_block = settings.controller.get_models({models: [Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_COMPONENT__], filter_field: {route_id: {value: settings.route_id}, blueprint_block_id: {value: settings.blueprint_block_id}, end_year_week: {value: prev_year_week}, removed: {value: 't', type: 'excludes'}}, limit: 1});
    
                // Als we hem eerst uit de route halen en dan weer terugzetten maken we onze aanpassing eigenlijk ongedaan.
                if(!_.is_empty(route_blueprint_block))
                    route_blueprint_block.set_field_data({field: 'end_year_week', value: end_year_week});
                else
                    route_blueprint_block = new Model({controller: settings.controller, name: Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_COMPONENT__, data: {route_id: settings.route_id, blueprint_block_id: settings.blueprint_block_id, start_year_week: start_date.getYearWeek(), end_year_week: end_year_week}});
    
                route_blueprint_block.commit_changes({reset_changed_data: false, reset_start_data: false});
            }
        }
    },
    
    format_route_blueprint_blocks(models, controller) {
        let function_groups         = controller.get_data({models: [Components.__FUNCTION_GROUP_COMPONENT__], format: 'asGrouped', key: ['id']});
        let customers               = controller.get_data({models: [Components.__CUSTOMER_COMPONENT__], format: 'asGrouped', key: ['id']});
        let customer_objects        = controller.get_data({models: [Components.__CUSTOMER_OBJECT_COMPONENT__], format: 'asGrouped', key: ['id']});
        let customer_object_zones   = controller.get_data({models: [Components.__CUSTOMER_OBJECT_ZONE_COMPONENT__], format: 'asGrouped', key: ['id']});

        for(let i in models)
        {
            if(models[i].component_id == Components.__PLANNING_ROUTE_RANDOM_SHIFT_COMPONENT__)
                continue;
            
            if(models[i].customer_id)
                models[i].customer = customers[models[i].customer_id].title;

            if(models[i].customer_object_id) {
                models[i].customer_object   = customer_objects[models[i].customer_object_id].title;
                models[i].object_code       = customer_objects[models[i].customer_object_id].object_code;
            }
            
            if(models[i].customer_object_zone_id)
                models[i].customer_object_zone = customer_object_zones[models[i].customer_object_zone_id].title;
            
            if(!models[i].color)
                models[i].color = function_groups[models[i].function_group_id].color;
        }
        
        return models;
    },
    
    // Planning item functions
    is_planning_recurring(settings) {
        let planning_recurring_users    = settings.planning_recurring_users;
        let week                        = (parseInt((settings.yearweek + '').substring(0, 4)) * 52) + parseInt((settings.yearweek + '').substring(4, 6));
        
        if(!planning_recurring_users && settings.controller)
        {
            planning_recurring_users    = {};
            let filter_field            = {user_id: {value: settings.user_id}, [settings.field]: {value: settings.record_id}};

            // We doen hier een merge omdat wanneer je hem aanroept vanuit unplan_recurring_planning de aanpassingen nog niet in de state staan. Waardoor hij in de unplan van de planning items anders uitzonderingen gaat maken voor de opvolgende weken.
            planning_recurring_users[settings.field]    = settings.controller.get_data_and_models({models: [Components.__PLANNING_RECURRING_USER_COMPONENT__, Components.__PLANNING_RECURRING_USER_EXCEPTION_COMPONENT__], merge: true, filter_field: filter_field, after_combine_filter_field: {removed: {value: 't', type: 'excludes'}}, format: 'asGrouped', key: {[settings.field]: {'user_id': '$auto_increment$'}}, sort: [{field: 'component_id', by: 'desc'}]});
        }
        
        if(planning_recurring_users[settings.field] && planning_recurring_users[settings.field][settings.record_id] && planning_recurring_users[settings.field][settings.record_id][settings.user_id])
        {
            for(let i in planning_recurring_users[settings.field][settings.record_id][settings.user_id])
            {
                let planning_recurring_user = planning_recurring_users[settings.field][settings.record_id][settings.user_id][i];
                let end_year_week           = planning_recurring_user.end_year_week;
                
                // from_removed_planning: Dit wordt gebruikt bij het publiceren in de planning. Mocht je een (periode) planning vast uitplannen wordt de end_year_week op vorige week gezet. De planning kijkt dan of een uitgepland item een vaste planning heeft zodat die registraties ook mee kunnen komen bij het publiceren. Zonder de from_removed_planning zou hij hieronder false teruggeven omdat de week niet van 4 weken terug is maar van vorige week. Daarom doen we er 1 week bij.
                if(settings.from_removed_planning && !_.is_empty(end_year_week))
                    end_year_week = moment(end_year_week, 'GGGGWW').add(1, 'week').format('GGGGWW');

                if(planning_recurring_user.start_year_week <= settings.yearweek && (_.is_empty(end_year_week) || end_year_week >= settings.yearweek))
                {
                    // Als het item verwijderd is kan het recurring item alleen maar verwijderd zijn of in het verleden liggen omdat hij is afgekapt
                    if((settings.from_removed_planning && planning_recurring_user.removed != 't' && (!_.is_empty(end_year_week) && end_year_week != settings.yearweek)) || (!settings.from_removed_planning && planning_recurring_user.removed == 't'))
                        continue;

                    // Als het een uitzondering is betekend dit altijd dat je iemand eenmalig hebt uitgepland
                    if(planning_recurring_user.component_id == Components.__PLANNING_RECURRING_USER_EXCEPTION_COMPONENT__)
                        return false;
                    
                    if(planning_recurring_user.periodic == 't')
                    {
                        let recurring_user_week = (parseInt((planning_recurring_user.start_year_week + '').substring(0, 4)) * 52) + parseInt((planning_recurring_user.start_year_week + '').substring(4, 6));
                        
                        if(Math.abs(week - recurring_user_week) % 4 == 0)
                            return planning_recurring_user;
                        
                        continue;
                    }
                    
                    return planning_recurring_user;
                }
            }
        }
        
        return false;
    },
    
    plan_recurring_planning(settings) {
        let model       = settings.controller.get_models_from_data({data: {models: [settings.component], filter_field: {id: {value: settings.id}, removed: {value: 't', type: 'excludes'}}}, models: {component_classes: (settings.component == Components.__PLANNING_ROUTE_COMPONENT__ || settings.component == Components.__PLANNING_SINGLE_ROUTE_COMPONENT__ ? RouteModel : BlueprintBlockModel), limit: 1}});
        let date        = _.clone(settings.start_date_time);
        let end_date    = model.get_field_data('end_date');
        
        // Als de einddatum van het blok buiten de periode valt, moeten we tot max einde periode gaan.
        if(end_date == null || end_date > settings.controller.component.state.periods[settings.controller.component.state.current_period_id].end_date)
            end_date = settings.controller.component.state.periods[settings.controller.component.state.current_period_id].end_date;

        let messages = {errors: [], warnings: []};

        if(!settings.periodic)
            while(date.getYearMonthDay() < end_date)
            {
                date.setDate(date.getDate() + 7);
                
                if(date.getYearMonthDay() > end_date)
                    break;
    
                if(!model.is_active_week({date: date.getYearMonthDay()}))
                    continue;

                let block_messages  = model.is_plannable({user_id: settings.user_id, date: _.clone(date.getYearMonthDay()), check_if_planned: false, atw_should_give_error: settings.atw_should_give_error || false}); //check_if_planned omdat hij hem niet hoeft in te plannen als je er op staat, maar wel vaste planning mag aanmaken
                messages.errors     = _.concat(messages.errors, block_messages.errors);
                messages.warnings   = _.concat(messages.warnings, block_messages.warnings);
            }

        date = _.clone(settings.start_date_time);
        
        let resolve = () => {
            let data                                                = {start_year_week: settings.start_date_time.getYearWeek(), user_id: settings.user_id, periodic: settings.periodic ? 't' : 'f'};
            let is_route                                            = (settings.component == Components.__PLANNING_ROUTE_COMPONENT__ || settings.component == Components.__PLANNING_SINGLE_ROUTE_COMPONENT__);
            data[(is_route ? 'route_id' : 'blueprint_block_id')]    = model.get_bind_id();
            let recurring_user_model                                = new Model({controller: settings.controller, name: Components.__PLANNING_RECURRING_USER_COMPONENT__, data: data});

            // Als er een huidige vaste planning is moeten we die eerst weghalen
            Planning.unplan_recurring_planning({controller: settings.controller, start_date_time: date, component: (is_route ? Components.__PLANNING_ROUTE_PLANNING_COMPONENT__ : Components.__PLANNING_COMPONENT__), id: settings.id, user_id: settings.user_id, unplan_planning: false, periodic: (settings.periodic ? 'f' : 't')});
            
            if(!settings.periodic)
                while(date.getYearMonthDay() < end_date)
                {
                    date.setDate(date.getDate() + 7);
                    
                    if(date.getYearMonthDay() > end_date)
                        break;

                    if(!model.is_active_week({date: date.getYearMonthDay()}))
                        continue;

                    model.plan({user_id: settings.user_id, date: _.clone(date.getYearMonthDay()), show_messages: false, remove_current: false});
                }

            recurring_user_model.commit_changes({reset_start_data: false, reset_changed_data: false});
        };
        
        if(_.size(messages.errors))
            settings.controller.component.setState({messageTitle: 'Let op', messageContent: messages.errors});
        else if(_.size(messages.warnings))
        {
            messages.warnings.push('');
            messages.warnings.push('Weet je zeker dat je deze medewerker evengoed wilt inplannen?');
            settings.controller.component.setState({messageTitle: 'Let op', messageContent: messages.warnings, messageConfirmCallback: resolve.bind(this)});
        }
        else
            resolve();
    },
    
    unplan_recurring_planning(settings) {
        settings            = {...{unplan_planning: true, periodic: null}, ...settings};
        let field           = (settings.component == Components.__PLANNING_COMPONENT__ ? 'blueprint_block_id' : 'route_id');
        let filter_field    = {[field]: {value: settings.id}, user_id: {value: settings.user_id}, week: {value: model => (model.start_year_week <= settings.start_date_time.getYearWeek() && _.if_empty(model.end_year_week, settings.start_date_time.getYearWeek()) >= settings.start_date_time.getYearWeek()), type: 'function'}, removed: {value: 't', type: 'excludes'}};
        
        // Vanuit het vast inplannen komt een vast uitplannen actie. Hierbij moeten alleen de tegenovergestelde vaste planningen worden uitgepland. Bijvoorbeeld als je van vast naar periodiek gaat of andersom. Anders krijg je bij periodiek in een periode waarbij week 1 periodiek is en week 3 ook, hij bij de vaste planning van week 3 meteen de end_year_week van week 1 zet. Wat niet de bedoeling is.
        if(settings.periodic !== null)
            filter_field.periodic   = {value: settings.periodic};
        else
            filter_field.periodic   = {value: model => (_.if_empty(model.periodic, 'f') == 'f' || (moment(settings.start_date_time).diff(moment(model.start_year_week, 'GGGGWW'), 'weeks')%4) == 0), type: 'function'}

        let recurring_user_models   = settings.controller.get_models_from_data({data: {models: [Components.__PLANNING_RECURRING_USER_COMPONENT__, Components.__PLANNING_RECURRING_USER_EXCEPTION_COMPONENT__], filter_field: filter_field}, models: {return_models_split_components: false}});
        let last_year_week          = _.clone(settings.start_date_time);

        // Vorige week
        last_year_week.setDate(last_year_week.getDate() - 7);

        for(let i in recurring_user_models)
        {
            let planning_items = null;

            // Vaste planning stoppen per vorige week, of wanneer het om een eenmalige uitzondering gaat. Want die wordt teniet gedaan door dit vast uitplannen
            if(last_year_week.getYearWeek() < recurring_user_models[i].get_field_data('start_year_week') || recurring_user_models[i].config.name == Components.__PLANNING_RECURRING_USER_EXCEPTION_COMPONENT__)
                recurring_user_models[i].remove();
            else
                recurring_user_models[i].set_field_data({field: 'end_year_week', value: last_year_week.getYearWeek()});

            recurring_user_models[i].commit_changes({reset_start_data: false, reset_changed_data: false});

            // Voor de uitzonderingen hoeven we geen planning items te verwijderen. Want die gebeurd al met de normale vaste planning. De uitzondering valt in een week altijd over de originele heen
            if(recurring_user_models[i].config.name == Components.__PLANNING_RECURRING_USER_COMPONENT__ && (settings.unplan_planning || recurring_user_models[i].get_field_data('periodic') != 't'))
            {
                if(settings.component == Components.__PLANNING_COMPONENT__)
                    planning_items = settings.controller.get_models_from_data({data: {models: [settings.component], filter_field: {blueprint_block_id: {value: settings.id}, removed: {value: 't', type: 'excludes'}, user_id: {value: recurring_user_models[i].get_field_data('user_id')}, date: {value: model => (recurring_user_models[i].get_field_data('periodic') == 't' && _.get_date_format(model.start_date_time, true) == settings.start_date_time.getYearMonthDay()) || (recurring_user_models[i].get_field_data('periodic') != 't' && model.start_date_time >= settings.start_date_time.getDateTime(true) && _.get_date_format(model.start_date_time, true) <= settings.controller.component.state.periods[settings.controller.component.state.current_period_id].end_date && (settings.unplan_planning || model.start_date_time != settings.start_date_time.getDateTime(true)))}}}, models: {component_classes: BlueprintBlockPlanningModel}});
                else
                    planning_items = settings.controller.get_models_from_data({data: {models: [settings.component], filter_field: {route_id: {value: settings.id}, removed: {value: 't', type: 'excludes'}, user_id: {value: recurring_user_models[i].get_field_data('user_id')}, date: {value: model => (recurring_user_models[i].get_field_data('periodic') == 't' && _.get_date_format(model.start_date_time, true) == settings.start_date_time.getYearMonthDay()) || (recurring_user_models[i].get_field_data('periodic') != 't' && model.start_date_time >= settings.start_date_time.getDateTime(true) && _.get_date_format(model.start_date_time, true) <= settings.controller.component.state.periods[settings.controller.component.state.current_period_id].end_date && (settings.unplan_planning || model.start_date_time != settings.start_date_time.getDateTime(true)))}}}, models: {component_classes: RoutePlanningModel}});

                for(let i in planning_items)
                    planning_items[i].unplan();
            }
        }
    },
    
    // Employee functions
    get_employee_supplement_profile_for_function_group(settings) {
        settings                = _.extend({check_date: new CustomDate().getYearMonthDay(), contract: null, supplement_profiles: null, supplement_profile_items: null}, settings);
        settings.check_date     = new CustomDate(settings.check_date);
        
        // Als functie groep leeg is, betekend dit dat het een tijdvak is, dus dan moeten we kijken of hij in de CAO particuliere beveiliging zit (ID = 1) of VBe zit (ID = 3)
        // Medewerker moet wel contract uren hebben. Anders geld verschuivingstoeslag niet.
        let employee_contract   = settings.contract || settings.controller.get_data({models: [Components.__CONTRACT_COMPONENT__], filter_field: {user_id: {value: settings.user_id}, function_group_ids: {value: model => (!settings.function_group_id ? (model.cao_id == 1 || model.cao_id == 3) : _.is_value_in_set(model.function_group_ids, settings.function_group_id))}, date: {value: model => settings.date >= model.start_date && settings.date <= _.if_empty(model.end_date, settings.date)}, min_hours: {value: model => _.if_empty(model.min_hours, 0) > 0 && _.if_empty(model.max_hours, 0) == 0}, article_3_2_applied: {value: 't', type: 'excludes'}}, limit: 1});

        // Medewerker heeft geen geldig contract. Daarom kunnen we niet bepalen of die een CAO heeft waar die een verschuivingstoeslag op kan berekenen. Of Artikel 3.2 is van toepassing
        if(_.size(employee_contract) == 0)
            return false;
            
        let supplement_profiles     = settings.supplement_profiles || settings.controller.get_data({models: [Components.__SUPPLEMENT_PROFILE_SHIFTING_COMPONENT__], format: 'asGrouped', key: 'id'});
        let cao_supplement_profile  = settings.cao_supplement_profile || settings.controller.get_data({models: [Components.__CAO_SUPPLEMENT_PROFILE_COMPONENT__], filter_field: {cao_id: {value: employee_contract.cao_id}, supplement_profile_id: {value: _.keys(supplement_profiles), type: 'includes_desc'}, function_group_ids: {value: model => _.is_empty(settings.function_group_id) || _.is_empty(model.function_group_ids) || _.is_value_in_set(model.function_group_ids, settings.function_group_id)}, date: {value: model => settings.date >= model.start_date && settings.date <= _.if_empty(model.end_date, settings.date)}}, limit: 1});

        if(_.size(cao_supplement_profile) == 0)
            return false;

        let supplement_profile_items = settings.supplement_profile_items || settings.controller.get_data({models: [Components.__SUPPLEMENT_PROFILE_SHIFTING_ITEM_COMPONENT__], filter_field: {supplement_profile_id: {value: cao_supplement_profile.supplement_profile_id}}});
        
        if(_.size(supplement_profile_items) == 0)
            return false;

        let one_day     = 1000*60*60*24;
        let difference  = Math.round((new CustomDate(settings.date).getTime() - settings.check_date.getTime())/one_day);
        
        if(difference < 0)
            difference = 0;
        
        for(let i in supplement_profile_items)
        {
            if(difference >= supplement_profile_items[i].start_day_number && difference <= supplement_profile_items[i].end_day_number)
            {
                if(difference >= 25)
                {
                    // Op donderdag moeten de roosters gepubliceerd worden. Dus de dagen ervoor geldt dan niet voor dat je 28 dagen vooruit moet kijken. Dit zei de jurist van de CAO:
                    // "De verschuivingstoeslag is pas van toepassing als de werkgever het rooster verandert nadat het rooster bekend is gemaakt. Dit staat in artikel 22 lid 1 sub a van de cao. De maandag, dinsdag en woensdag van de nieuwste week vallen inderdaad binnen de 28 dagen, maar daar is geen verschuivingstoeslag over verschuldigd omdat het rooster nog niet bekend is gemaakt (en dus ook niet verandert)."
                    if(settings.check_date.getDayNumber() <= 3)
                        continue;
                }
                
                return {supplement: supplement_profile_items[i], days: difference};
            }
        }

        return false;
    },
    
    // Schedule free functions
    plan_schedule_free(settings) {
        if(!this.is_free_day({controller: settings.controller, user_id: settings.data.user_id, date: _.get_date_format(settings.data.start_date_time, true)}))
            settings.controller.component.setState({messageTitle: 'Let op', messageContent: ['Je wilt een roostervrije dag inplannen op een dag waar de medewerker niet vrij is. Plan eerst de diensten uit die ervoor zorgen dat het geen vrije dag is.']});
        else
        {
            let is_already_schedule_free = settings.controller.get_data_and_models({models: [Components.__PLANNING_USER_UNAVAILABILITY_SCHEDULE_FREE_COMPONENT__], filter_field: {user_id: {value: settings.data.user_id}, start_date_time: {value: settings.data.start_date_time}, removed: {value: 't', type: 'excludes'}}});

            if(_.is_empty(is_already_schedule_free))
            {
                let schedule_free_model = new PlanningUserAvailabilityScheduleFreeModel({controller: settings.controller, name: Components.__PLANNING_USER_UNAVAILABILITY_SCHEDULE_FREE_COMPONENT__, data: settings.data});
    
                schedule_free_model.plan();
            }
        }
    },
    
    // CAO functions
    is_evening_shift(settings) {
        return _.get_time_format(settings.end_date_time) > '20:00' || _.get_time_format(settings.end_date_time) <= '02:00';
    },
    
    is_night_shift(settings) {
        let crossing_period_start_date  = _.is_crossing_datetime_period(settings.start_date_time, settings.end_date_time, (_.get_date_format(settings.start_date_time, true) + ' 00:00:00'), (_.get_date_format(settings.start_date_time, true) + ' 05:59:59'));
        let crossing_period_end_date    = _.is_crossing_datetime_period(settings.start_date_time, settings.end_date_time, (_.get_date_format(settings.end_date_time, true) + ' 00:00:00'), (_.get_date_format(settings.end_date_time, true) + ' 05:59:59'));

        // We weten niet of de dienst in de nacht begint of in de avond en doorloopt naar de nacht. Daarom moeten we beide controleren om erachter te komen wat voor een type dienst het is.
        if(!crossing_period_start_date && !crossing_period_end_date)
            return false;
        
        let start_time  = '00:00';
        let end_time    = '06:00';
        
        if(_.get_time_format(settings.start_date_time) < '06:00')
            start_time = _.get_time_format(settings.start_date_time);
        
        if(_.get_time_format(settings.end_date_time) < end_time)
            end_time = _.get_time_format(settings.end_date_time);

        let duration = _.time_to_minutes(end_time) - _.time_to_minutes(start_time);
        
        // Een dienst waarvan meer dan een uur arbeid wordt verricht tussen 00.00 en 06.00 uur.
        return (duration > 60);
    },
    
    is_free_day(settings) {
        let yesterday   = new CustomDate(settings.date);
        let tomorrow    = new CustomDate(settings.date);
        
        yesterday.setDate(yesterday.getDate() - 1);
        tomorrow.setDate(tomorrow.getDate() + 1);

        let filter_field = {user_id: {value: settings.user_id}, removed: {value: 't', type: 'excludes'}, time: {value: model => {
            let model_data = (model instanceof Model ? model.data : model);

            return _.get_date_format(model_data.start_date_time, true) == settings.date || _.get_date_format(model_data.end_date_time, true) == settings.date || _.get_date_format(model_data.start_date_time, true) == tomorrow.getYearMonthDay() || _.get_date_format(model_data.end_date_time, true) == tomorrow.getYearMonthDay();
        }}}
        
        let planning_items = settings.controller.get_data_and_models({models: [Components.__PLANNING_COMPONENT__, Components.__PLANNING_ROUTE_PLANNING_COMPONENT__, Components.__PLANNING_TIME_PERIOD_COMPONENT__], filter_field: filter_field, format: models => {
            let formatted_data = {};

            for(let i in models)
            {
                let date = _.get_date_format(models[i].start_date_time, true);
                
                _.set_object_chain(formatted_data, {chain: [date], value: []});
                
                formatted_data[date].push(models[i]);
            }
            
            return formatted_data;
        }});
        
        // Als we hem vanuit de check op het inplannen aanroepen bestaat het in te plannen record nog niet. Vandaar dat we een optie bieden om hem hier toe te voegen.
        if(settings.new_planning_item)
        {
            let date = _.get_date_format(settings.new_planning_item.start_date_time, true);
            
            _.set_object_chain(planning_items, {chain: [date], value: []});
                
            planning_items[date].push(settings.new_planning_item);
        }

        // CAO: Vrije dag = Een dag zonder begintijd van een dienst na 00.00 en vóór 24.00 uur
        if(planning_items[settings.date])
            return false;

        // Als er op de dag zelf geen dienst is, moeten we kijken of er genoeg rusttijd is voor de dag na vandaag. Want als een dienst eindigd op 07:00 op de dag van de rustdag, moeten ze daarna 32 uur vrij zijn om de dag van een rustdag te laten gelden als vrije dag.
        if(planning_items[yesterday.getYearMonthDay()])
        {
            let last_planning_item = null;
            
            // De laatste dienst ophalen voordat de vrije dag begint. Vanaf deze dienst moet dan de rustijd berekend worden.
            for(let i in planning_items[yesterday.getYearMonthDay()])
            {
                if(last_planning_item == null || last_planning_item.end_date_time < planning_items[yesterday.getYearMonthDay()][i].end_date_time)
                    last_planning_item = planning_items[yesterday.getYearMonthDay()][i];
            }

            let is_night_shift          = this.is_night_shift({...last_planning_item, ...{date: settings.date}});
            let rest_hours              = (is_night_shift ? 32 : 24);
            let rest_start_date_time    = new CustomDate(last_planning_item.end_date_time);
            let rest_end_date_time      = new CustomDate(last_planning_item.end_date_time);

            rest_start_date_time.setMinutes(rest_start_date_time.getMinutes() + 1); // Omdat anders de eigen dienst ook wordt gezien als een periode waarin gewerkt wordt. Moet een minuut zijn want is_crossing_datetime_period haalt de seconden weg.
            rest_end_date_time.setHours(rest_end_date_time.getHours() + rest_hours);
            rest_end_date_time.setSeconds(rest_end_date_time.getSeconds() - 1); // Geld hetzelfde voor als de + 1 bij de starttijd, maar dan andersom.

            // Door alle planning_items heenloopen om te kijken of er een dienst is in de rusttijd die de medewerker zou moeten krijgen.
            for(let date in planning_items)
                for(let i in planning_items[date])
                {
                    // Als er een dienst binnen de rusttijd valt geld deze dag niet als vrije dag.
                    if(_.is_crossing_datetime_period(planning_items[date][i].start_date_time, planning_items[date][i].end_date_time, rest_start_date_time.getDateTime(true), rest_end_date_time.getDateTime(true)))
                        return false;
                }
        }
        
        // Als er zowel gisteren als vandaag geen geplande diensten zijn heb je sowieso altijd genoeg rusttijd.
        return true;
    },
    
    get_night_shift_serie(settings) {
        let end_date_time;
        if(typeof settings.end_date_time === "string")
            end_date_time = settings.end_date_time
        else
            end_date_time = settings.end_date_time.getDateTime(true)
        
        let adjacent_night_shifts   = {before: {id: settings.id, component_id: settings.component_id, amount: 0, date_time: settings.start_date_time}, after: {id: settings.id, component_id: settings.component_id, amount: 0, date_time: end_date_time}};
        let date                    = (_.get_date_format(settings.start_date_time) != settings.end_date_time ? settings.end_date_time : _.get_date_format(settings.start_date_time, true));
        
        // for loop gebruiken, anders moeten we code kopieren
        for(let type in adjacent_night_shifts)
        {
            let check_date = new CustomDate(date);

            for(let i = 0;i < 7;i++)
            {
                if(type == 'before')
                    check_date.setDate(check_date.getDate() - 1);
                else
                    check_date.setDate(check_date.getDate() + 1);
                
                let filter = {user_id: {value: settings.user_id}, removed: {value: 't', type: 'excludes'}, time: {value: model => {
                    let model_data = (model instanceof Model ? model.data : model);
                    
                    return _.is_crossing_datetime_period(model_data.start_date_time, model_data.end_date_time, check_date.getYearMonthDay() + ' 00:00:00', check_date.getYearMonthDay() + ' 05:59:59')
                }}};
                
                // De diensten ophalen die in de nacht vallen van deze datum
                let adjacent_night_planning = settings.controller.get_data_and_models({models: [Components.__PLANNING_COMPONENT__, Components.__PLANNING_ROUTE_PLANNING_COMPONENT__, Components.__PLANNING_TIME_PERIOD_COMPONENT__, Components.__SELF_SCHEDULE_PLANNING_COMPONENT__], filter_field: filter, models_object: 'array'});

                if(_.size(adjacent_night_planning) == 0)
                    break;

                let date_night_shift = false;
                
                // Per dienst kijken of het voldoet aan de nachtdienst eisen.
                for(let i in adjacent_night_planning)
                    if(Planning.is_night_shift({date: check_date.getYearMonthDay(), start_date_time: adjacent_night_planning[i].start_date_time, end_date_time: adjacent_night_planning[i].end_date_time}))
                    {
                        date_night_shift = true;
                        
                        if((type == 'before' && adjacent_night_shifts[type].date_time > adjacent_night_planning[i].start_date_time) || (type == 'after' && adjacent_night_shifts[type].date_time < adjacent_night_planning[i].end_date_time))
                        {
                            adjacent_night_shifts[type].id              = adjacent_night_planning[i].id;
                            adjacent_night_shifts[type].component_id    = adjacent_night_planning[i].component_id;
                            adjacent_night_shifts[type].date_time       = (type == 'before' ? adjacent_night_planning[i].start_date_time : adjacent_night_planning[i].end_date_time);
                        }
                    }

                if(date_night_shift)
                    adjacent_night_shifts[type].amount++;
                else
                    break;
            }
        }
        
        return adjacent_night_shifts;
    },
    
    get_previous_night_shifts(settings) {
        const previous_night_shifts = [];
    
        const end_date      = moment(settings.start_date_time);
        const start_date    = end_date.clone().subtract(5, 'days');
    
        // Haal de diensten op van de afgelopen 5 dagen van de betreffende medewerker
        // Als er een reeks is voorafgaande aan de in te plannen dienst moet dat te zien zijn in die 5 dagen, anders is er voldoende rusttijd geweest
        const filter = {
            user_id: { value: settings.user_id },
            removed: { value: 't', type: 'excludes' },
            time: { value: model => {
                const model_data = (model instanceof Model ? model.data : model);
    
                const shift_start = moment(model_data.start_date_time);
                const shift_end = moment(model_data.end_date_time);
    
                // Check of de dienst overlapt met de periode van 7 dagen
                return shift_start.isBetween(start_date, end_date, null, '[]') ||
                       shift_end.isBetween(start_date, end_date, null, '[]') ||
                       (shift_start.isBefore(start_date) && shift_end.isAfter(end_date));
            }}
        };
    
        // Diensten ophalen
        const shifts = settings.controller.get_data_and_models({ models: [Components.__PLANNING_COMPONENT__, Components.__PLANNING_ROUTE_PLANNING_COMPONENT__, Components.__PLANNING_TIME_PERIOD_COMPONENT__, Components.__SELF_SCHEDULE_PLANNING_COMPONENT__], filter_field: filter, models_object: 'array', sort: [{ field: 'start_date_time' }] });
    
        for (let shift of shifts) {
            if (Planning.is_night_shift({ date: moment(shift.start_date_time).format('YYYY-MM-DD'), start_date_time: shift.start_date_time, end_date_time: shift.end_date_time }))
                previous_night_shifts.push(shift);
        }
    
        return previous_night_shifts;
    },
    
    is_active_week(settings) {
        settings = { frequency: 1, ...settings };
        
        if(_.if_empty(settings.frequency, 1) != 1)
        {
            // altijd eerste maandag pakken zodat het aantal weken altijd klopt zelfs als dagen verschillen doordat dag van de planning anders is
            let setting_start_date  = new CustomDate(settings.setting_start_date);
            setting_start_date      = (setting_start_date.setDate(setting_start_date.getDate() + (7-setting_start_date.getDay())%7+1) / 1000) - (60*60*24*7);
            let shift_date    		= new CustomDate(settings.shift_date);
            shift_date        		= (shift_date.setDate(shift_date.getDate() + (7-shift_date.getDay())%7+1) / 1000) - (60*60*24*7);
            let weeks               = Math.round((shift_date - setting_start_date) / (60*60*24*7));

            if(weeks > 0 && (weeks % parseInt(settings.frequency)) != 0)
                return false
        }
        
        return true;
    },
    
    calculatePauseDuration(settings) {
        let return_unit = settings.return_unit || 'minutes';
        let duration    = 0;
        let pauses      = settings.shift.pauses;
        
        if(pauses)
            for(let i in pauses)
            {
                if((settings.paused_by_user === true && pauses[i].paused_by_user != 't') || (settings.paused_by_user === false && pauses[i].paused_by_user == 't'))
                    continue;
                
                if(_.isEmpty(pauses[i].start_time) || _.isEmpty(pauses[i].end_time))
                    continue;

                let shift_start_date_time   = moment.isMoment(settings.start_date_time) ? settings.start_date_time : getMomentObject(settings.start_date_time || settings.date + ' ' + settings.shift.start_time);
                let shift_end_date_time     = moment.isMoment(settings.end_date_time) ? settings.end_date_time : (settings.end_date_time ? getMomentObject(settings.end_date_time) : moment(shift_start_date_time).add({ minutes: _.time_to_minutes(settings.shift.duration) }));
                
                let pause_start             = moment(getMomentObject(settings.date + ' ' + _.get_time_format(pauses[i].start_time, true)));
                
                // Als de pauze tijd voor de starttijd van de dienst valt moet ie op de volgende dag vallen (voor een dienst die over gaat naar de volgende dag).
                if(pause_start.isBefore(shift_start_date_time))
                    pause_start.add({ day: 1 });
                
                let pause_end = moment(getMomentObject(pause_start.format('YYYY-MM-DD') + ' ' + _.get_time_format(pauses[i].end_time, true)));
                
                // start_time groter dan end_time betekend dat end_time op de volgende dag valt.
                if(pauses[i].end_time < pauses[i].start_time)
                    pause_end.add({ day: 1 });
                
                if(shift_end_date_time.isBefore(pause_start) || pause_end.isBefore(shift_start_date_time))
                    continue;
                
                duration += pause_end.diff(pause_start, return_unit);
            }
        
        return duration;
    },
    
    check_24_hour_notation(time, display_as_24) {
        if(display_as_24 && time == '00:00')
            return '24:00';
        
        return time;
    },
    
    construct_object_data(settings) {
        let data = {};
        
        if(!settings.customer_object && !_.is_empty(settings.customer_object_id) && settings.customer_objects)
            settings.customer_object = settings.customer_objects[settings.customer_object_id];
        
        if(settings.customer_object)
        {
            data.display_title  = settings.customer_object.title;
            data.documents      = [];
            
            // Instructies.
            if(settings.date && !_.is_empty(settings.customer_object_instructions) && !_.is_empty(settings.customer_object_instructions[settings.customer_object.id]))
                for(let i in settings.customer_object_instructions[settings.customer_object.id])
                {
                    if(settings.date >= settings.customer_object_instructions[settings.customer_object.id][i].start_date && (_.is_empty(settings.customer_object_instructions[settings.customer_object.id][i].end_date) || settings.customer_object_instructions[settings.customer_object.id][i].end_date >= settings.date))
                    {
                        if(_.is_empty(settings.customer_object_instructions[settings.customer_object.id][i].function_group_ids) || _.is_value_in_set(settings.customer_object_instructions[settings.customer_object.id][i].function_group_ids, settings.function_group_id))
                            if(_.is_empty(settings.customer_object_instructions[settings.customer_object.id][i].customer_object_zone_ids) || _.is_value_in_set(settings.customer_object_instructions[settings.customer_object.id][i].customer_object_zone_ids, settings.customer_object_zone_id))
                                if(_.is_empty(settings.customer_object_instructions[settings.customer_object.id][i].customer_object_project_ids) || _.is_value_in_set(settings.customer_object_instructions[settings.customer_object.id][i].customer_object_project_ids, settings.customer_object_project_id))
                                    data.instructions = (!_.is_empty(data.instructions) ? data.instructions + "\n\n" : '') + settings.customer_object_instructions[settings.customer_object.id][i].instruction;
                    }
                }
            
            // Object documenten.
            if(settings.customer_object_documents)
            {
                for(let i in settings.customer_object_documents[settings.customer_object.id])
                    if(_.is_empty(settings.customer_object_documents[settings.customer_object.id][i].function_group_ids) || _.is_value_in_set(settings.customer_object_documents[settings.customer_object.id][i].function_group_ids, settings.function_group_id))
                        if(_.is_empty(settings.customer_object_documents[settings.customer_object.id][i].customer_object_zone_ids) || _.is_value_in_set(settings.customer_object_documents[settings.customer_object.id][i].customer_object_zone_ids, settings.customer_object_zone_id))
                            if(_.is_empty(settings.customer_object_documents[settings.customer_object.id][i].customer_object_project_ids) || _.is_value_in_set(settings.customer_object_documents[settings.customer_object.id][i].customer_object_project_ids, settings.customer_object_project_id))
                                data.documents.push(settings.customer_object_documents[settings.customer_object.id][i]);
            }

            // Klant documenten.
            if(settings.customer_documents && settings.customer_documents[settings.customer_object.customer_id])
            {
                for(let i in settings.customer_documents[settings.customer_object.customer_id])
                    data.documents.push(settings.customer_documents[settings.customer_object.customer_id][i]);
            }
        }
        
        // Object zone.
        if(!_.is_empty(settings.customer_object_zones) && !_.is_empty(settings.customer_object_zone_id))
            data.customer_object_zone = settings.customer_object_zones[settings.customer_object_zone_id];
        
        // Object project.
        if(!_.is_empty(settings.customer_object_projects) && !_.is_empty(settings.customer_object_project_id))
            data.display_title = settings.customer_object_projects[settings.customer_object_project_id].title;
        
        if(settings.include_object_code === true && settings.customer_object && !_.is_empty(settings.customer_object.object_code))
            data.display_title = '(' + settings.customer_object.object_code + ') ' + data.display_title;
        
        return data;
    },
    
    construct_planning_item(settings) {
        let model               = settings.model;
        let planning_settings   = null;
        
        if(!settings.date && !_.is_empty(model.start_date_time))
            settings.date = _.get_date_format(model.start_date_time, true);
        
        if(!settings.year_week)
            settings.year_week = moment(settings.date).format('GGGGWW');
        
        // Medewerker naam koppelen.
        if(settings.employees && settings.employees[model.user_id])
            model.employee_display_name = settings.employees[model.user_id].display_name;
        
        if(model.component_id == Components.__PLANNING_COMPONENT__ || model.component_id == Components.__PLANNING_ROUTE_PLANNING_TASK_COMPONENT__)
        {
            if(settings.blueprint_blocks)
                planning_settings = this.get_blueprint_block_data_for_date({ blueprint_block: settings.blueprint_blocks[model.blueprint_block_id], year_week: settings.year_week, settings: settings.blueprint_block_settings[model.blueprint_block_id], exceptions: settings.blueprint_block_exceptions ? settings.blueprint_block_exceptions[model.blueprint_block_id] : null });
            else
                planning_settings = this.get_blueprint_block_setting_data_for_date({ blueprint_block_id: model.blueprint_block_id, year_week: settings.year_week, settings: settings.blueprint_block_settings[model.blueprint_block_id], exceptions: settings.blueprint_block_exceptions ? settings.blueprint_block_exceptions[model.blueprint_block_id] : null });
            
            model.customer_object   = settings.customer_objects[planning_settings.customer_object_id || model.customer_object_id];
            model.comments          = planning_settings.comments;
            let object_data         = this.construct_object_data({ ..._.pick(settings, ['customer_object_zones', 'customer_object_projects', 'customer_object_instructions', 'customer_object_documents', 'customer_documents', 'date', 'include_object_code']), customer_object: model.customer_object, function_group_id: (planning_settings.function_group_id || model.function_group_id), customer_object_zone_id: planning_settings.customer_object_zone_id, customer_object_project_id: planning_settings.customer_object_project_id });
            
            for(let i in object_data)
                model[i] = object_data[i];
            
            if(model.customer_object)
            {    
                if(!_.is_empty(model.instructions))
                    model.comments = (!_.is_empty(model.comments) ? model.comments + "\n\n" : '') + model.instructions;
                
                if(!_.is_empty(model.customer_object.information))
                    model.comments = (!_.is_empty(model.comments) ? model.comments + "\n\n" : '') + model.customer_object.information;
            }
            
            model.register_location         = planning_settings.register_location;
            model.on_location_method        = planning_settings.on_location_method;
            model.on_location_checkpoint_id = planning_settings.on_location_checkpoint_id;

            if(settings.exceeded_registrations && settings.exceeded_registrations[model.id])
            {
                if(!_.is_empty(settings.exceeded_registrations[model.id].start_date_time))
                    model.start_date_time = settings.exceeded_registrations[model.id].start_date_time;

                if(!_.is_empty(settings.exceeded_registrations[model.id].end_date_time))
                    model.end_date_time = settings.exceeded_registrations[model.id].end_date_time;
            }
        }
        else if(model.component_id == Components. __PLANNING_ROUTE_PLANNING_COMPONENT__)
        {
            planning_settings   = this.get_route_data_for_date({ route: settings.routes[model.route_id], year_week: settings.year_week, settings: settings.route_settings[model.route_id], exceptions: settings.route_exceptions ? settings.route_exceptions[model.route_id] : null, route_parents: settings.route_parents });
            model.display_title = planning_settings.title;
            model.comments      = planning_settings.comments;
            model.region_id     = planning_settings.region_id;
        }
        else if(model.component_id == Components.__PLANNING_TIME_PERIOD_COMPONENT__)
        {
            model.display_title = 'Tijdvak';
            model.color         = 'purple';
        }
        else if(model.component_id == Components.__PLANNING_USER_UNAVAILABILITY_SCHEDULE_FREE_COMPONENT__)
        {
            model.display_title = 'Roostervrij' + (_.is_empty(model.comments) ? '' : ' (' + model.comments + ')');
            model.color         = 'grey';
            
            delete model.comments;
        }
        
        if(planning_settings)
        {
            model.function_group_object = settings.function_groups[planning_settings.function_group_id || model.function_group_id];
            model.color                 = (planning_settings.color || model.function_group_object.color).trim();
            
            if(planning_settings.deviating_payroll_time && planning_settings.deviating_payroll_time.active == 't' && (!settings.use_invoice_time || settings.use_invoice_time === false))
                applyDeviatingPayrollTime(model, planning_settings);

            if(planning_settings.vehicle_id)
            {
                model.vehicle_id = planning_settings.vehicle_id;

                if(settings.vehicles && settings.vehicles[planning_settings.vehicle_id])
                    model.vehicle = settings.vehicles[planning_settings.vehicle_id];
            }

            return planning_settings;
        }
    }
}

export const CustomerContractArrangement = {
    get_closest_rate(settings) {
        for(let i in settings.rates)
            if((settings.rates[i].start_date <= settings.date && _.if_empty(settings.rates[i].end_date, settings.date) >= settings.date) || settings.rates[i].start_date > settings.date)
                return settings.rates[i];

        return {};
    },
    
    get_active_rate(settings) {
        settings = { id_field: 'customer_contract_arrangement_id', date: new CustomDate().getYearMonthDay(), return_type: 'active', ...settings };
        
        if(!_.is_empty(settings.component) && !_.is_empty(settings.controller))
        {
            if(settings.return_type == 'closest')
            {
                let rates = settings.controller.get_data_and_models({models: [settings.component], filter_field: {[settings.id_field]: (_.is_empty(settings.id) ? {value: [undefined, null], type: 'excludes_desc'} : {value: settings.id}), removed: {value: 't', type: 'excludes'}}, sort: [{ field: 'start_date' }], format: 'asGrouped', key: { [settings.id_field]: '$auto_increment$' }});
                
                if(_.is_empty(rates))
                    return [];
                
                for(let arrangement_id in rates)
                    rates[arrangement_id] = this.get_closest_rate({ rates: rates[arrangement_id], date: settings.date });
                
                if(!_.is_empty(settings.id))
                    return rates[settings.id];
                
                return rates;
            }
            else if(settings.return_type == 'active')
                return settings.controller.get_data_and_models({models: [settings.component], filter_field: {[settings.id_field]: (_.is_empty(settings.id) ? {value: [undefined, null], type: 'excludes_desc'} : {value: settings.id}), removed: {value: 't', type: 'excludes'}, start_date: {value: settings.date, type: '<='}, end_time: {value: rate => (_.is_empty(rate.end_date) || rate.end_date >= settings.date), type: 'function'}}, ...(_.is_empty(settings.id) ? {format: 'asGrouped', key: settings.id_field} : {limit: 1})});
        }
        else if(!_.is_empty(settings.rates))
        {
            if(settings.return_type == 'closest')
            {
                let rates = _.sortBy(settings.rates, 'start_date');
                
                return this.get_closest_rate({ rates: rates, date: settings.date });
            }
            else if(settings.return_type == 'active')
                return _.find(settings.rates, rate => (rate.start_date <= settings.date && (_.is_empty(rate.end_date) || rate.end_date >= settings.rate))) || [];
        }
        
        return null;
    }
};

export const Contract = {
    get_period_company_contracts(settings) {
        settings            = { calculate_hours: true, calculate_rates: true, ...settings };
        let formatted_data  = {};
        let year_periods    = 13;
        
        if(settings.controller)
        {
            if(!settings.contracts)
                settings.contracts = settings.controller.get_data({ models: [Components.__CONTRACT_COMPONENT__], sort: [{ field: 'start_date' }] });
            
            if(settings.calculate_hours)
            {
                if(!settings.user_min_hours)
                    settings.user_min_hours = settings.controller.get_data({ models: [Components.__PAYROLL_MIN_AND_OVERTIME_HOURS_COMPONENT__], format: 'asGrouped', key: { id: 'company_id' } });

                if(!settings.user_time_for_time)
                    settings.user_time_for_time = settings.controller.get_data({ models: [Components.__PAYROLL_TIME_FOR_TIME_COMPONENT__], format: 'asGrouped', key: { user_id: 'company_id' } });

                if(!settings.resignations)
                    settings.resignations = settings.controller.get_data({ models: [Components.__RESIGNATION_COMPONENT__], format: 'asGrouped', key: 'user_id' });
            }
            
            if(settings.calculate_rates)
            {
                if(!settings.contract_rates)
                    settings.contract_rates = settings.controller.get_data({ models: [Components.__CONTRACT_RATE_COMPONENT__], format: 'asGrouped', key: { contract_id: 'id' } });
                
                if(!settings.users)
                    settings.users = settings.controller.get_data({ models: [Components.__EMPLOYEE_COMPONENT__], format: 'asGrouped', key: 'id' });
                
                if(!settings.wage_tables)
                    settings.wage_tables = settings.controller.get_data({ models: [Components.__WAGE_TABLE_COMPONENT__], format: 'asGrouped', key: 'id' });
                
                if(!settings.cao_wage_tables)
                    settings.cao_wage_tables = settings.controller.get_data({ models: [Components.__CAO_WAGE_TABLE_COMPONENT__], format: 'asGrouped', key: { cao_id: 'wage_table_id' } });
                
                if(!settings.cao_salary_scales)
                    settings.cao_salary_scales = settings.controller.get_data({ models: [Components.__CAO_SALARY_SCALE_COMPONENT__], format: 'asGrouped', key: { cao_wage_table_id: 'scale' } });
                
                if(!settings.cao_salary_scale_periodicals)
                    settings.cao_salary_scale_periodicals = settings.controller.get_data({ models: [Components.__CAO_SALARY_SCALE_PERIODIC_COMPONENT__], format: 'asGrouped', key: { cao_salary_scale_id: 'periodic' } });
            }
        }
        
        if(!settings.today)
            settings.today = new CustomDate().getYearMonthDay();

        if(settings.period_type_id == 4)
            year_periods = 12; // maanden
        else if(settings.period_type_id == 2)
            year_periods = 52; // weken
        else if(settings.period_type_id == 5)
            year_periods = 4; // kwartalen

        for(let i in settings.contracts)
        {
            let contract = settings.contracts[i];
            
            if(settings.calculate_hours)
            {
                contract.time = { planning: 0, leave: 0, leave_top_off_contract: 0, sickness: 0, sickness_top_off_contract: 0, min_minutes: 0, time_for_time_minutes: 0 };
                
                if(settings.resignations && settings.resignations[contract.user_id] && _.is_value_in_set(settings.resignations[contract.user_id].company_ids, contract.company_id))
                {
                    if(settings.resignations[contract.user_id].date >= contract.start_date && settings.resignations[contract.user_id].date <= _.if_empty(contract.end_date, settings.resignations[contract.user_id].date) && settings.resignations[contract.user_id].date >= settings.period.start_date && settings.resignations[contract.user_id].date <= settings.period.end_date)
                        contract.end_date = settings.resignations[contract.user_id].date;
                    else if(settings.resignations[contract.user_id].date < settings.period.start_date && settings.period.start_date > settings.today) // Persoon is uit dienst gemeld in de toekomst, dus hoeft niet meer getoond te worden in een toekomstige periode.
                        continue;
                }
    
                if(contract.min_hours)
                {
                    contract.day_min_hours      = (contract.min_hours / 5);
                    
                    // Wanneer er een 14e periode is moeten de uren maar voor 1 week getoond worden
                    if(settings.period_type_id == 3 && settings.period.end_year_week.toString().endsWith('53') && !settings.extra_week) {
                        contract.period_min_hours   = contract.min_hours;
                    } else {
                        contract.period_min_hours   = ((contract.min_hours * 52) / year_periods) + (settings.extra_week ? contract.min_hours : 0);
                    }
    
                    // Mocht het contract niet aan het begin van de periode aanvangen, dan moeten we berekenen hoeveel dagen hij in deze periode zit en de uren dan terugrekenen naar het aantal te werken dagen.
                    if((contract.start_date > settings.period.start_date && contract.start_date <= settings.period.end_date) || (_.if_empty(contract.end_date, settings.period.end_date) >= settings.period.start_date && _.if_empty(contract.end_date, settings.period.end_date) < settings.period.end_date))
                    {
                        let period_start_date           = new CustomDate(settings.period.start_date);
                        let contract_start_date         = new CustomDate((contract.start_date > settings.period.start_date ? contract.start_date : settings.period.start_date));
                        let contract_end_date           = (!_.is_empty(contract.end_date) && contract.end_date < settings.period.end_date ? contract.end_date : settings.period.end_date);
                        let period_days                 = Math.floor(period_start_date.getDiff({date_time: settings.period.end_date})/60/24) + 1;
                        let contract_days               = Math.floor(contract_start_date.getDiff({date_time: contract_end_date})/60/24) + 1;
                        contract.period_min_hours       = (contract_days * contract.period_min_hours) / period_days;
                    }
                    else
                        contract.period_min_hours = contract.period_min_hours;
                }
            }
            
            if(settings.calculate_rates)
            {
                contract.contract_rates = [];
                
                for(let x in settings.contract_rates[contract.id])
                {
                    let contract_rate = settings.contract_rates[contract.id][x];
    
                    if(contract_rate.scale && contract_rate.periodical)
                    {
                        let user    = settings.users[contract.user_id];
                        let age     = 25; // fallback, zodat we altijd het volwassen tarief pakken als er geen geboortedatum is ingevuld.
            
                        // We pakken de end_date omdat wanneer je in de periode ouder wordt je de gehele periode het loon krijgt op die leeftijd.
                        if(!_.is_empty(user.date_of_birth))
                            age = moment(settings.period.end_date).diff(moment(user.date_of_birth), 'years');
                        
                        if(!settings.cao_wage_tables[contract.cao_id])
                            continue;
                        
                        for(let wage_table_id in settings.cao_wage_tables[contract.cao_id])
                        {
                            let wage_table = settings.wage_tables[wage_table_id];
            
                            if(wage_table.age_from > age || wage_table.age_until < age || !((!contract_rate.start_date || contract_rate.start_date <= _.if_empty(settings.cao_wage_tables[contract.cao_id][wage_table_id].end_date, contract_rate.start_date)) && (!contract_rate.end_date || contract_rate.end_date >= settings.cao_wage_tables[contract.cao_id][wage_table_id].start_date)))
                                continue;
            
                            let cao_wage_table      = settings.cao_wage_tables[contract.cao_id][wage_table_id];
                            let cao_salary_scale    = settings.cao_salary_scales[cao_wage_table.id][contract_rate.scale];
                            
                            if(cao_salary_scale)
                            {
                                let cao_salary_scale_periodical = settings.cao_salary_scale_periodicals[cao_salary_scale.id][contract_rate.periodical];
                                
                                if(cao_salary_scale_periodical)
                                    contract_rate.hour_rate = cao_salary_scale_periodical ? cao_salary_scale_periodical.hour_rate : 0;
                            }
                        }
                    }
                    
                    if(_.is_empty(contract_rate.start_date))
                        contract_rate.start_date = contract.start_date;
                    
                    if(_.is_empty(contract_rate.end_date))
                        contract_rate.end_date = contract.end_date;
                    
                    contract.contract_rates.push(contract_rate);
                }
            }
            
            if(settings.calculate_hours && settings.user_min_hours[contract.user_id] && settings.user_min_hours[contract.user_id][contract.company_id])
                contract.time.min_minutes = settings.user_min_hours[contract.user_id][contract.company_id].minutes;
            
            if(settings.calculate_hours && settings.user_time_for_time[contract.user_id] && settings.user_time_for_time[contract.user_id][contract.company_id])
                contract.time.time_for_time_minutes = settings.user_time_for_time[contract.user_id][contract.company_id].minutes;
            
            _.set_object_chain(formatted_data, {chain: [contract.user_id], value: {}});
            
            if(!formatted_data[contract.user_id][contract.company_id])
                formatted_data[contract.user_id][contract.company_id] = _.cloneData(contract);
            else
            {
                formatted_data[contract.user_id][contract.company_id].function_group_ids += ',' + contract.function_group_ids;
                
                if(settings.calculate_rates)
                    for(let y in contract.contract_rates)
                        formatted_data[contract.user_id][contract.company_id].contract_rates.push({...contract.contract_rates[y], function_group_ids: contract.function_group_ids});

                // Onderstaande waardes zetten we wanneer iemand een contract bij 2 bedrijf heeft met 2 tarieven. Bijv. een evenement tarief en een regulier tarief. Dan zijn er 2 contracten.
                if(contract.secondary_employment == 't')
                    continue;
                
                if(_.if_empty(formatted_data[contract.user_id][contract.company_id].min_hours, 0) < !_.is_empty(contract.min_hours, 0))
                    formatted_data[contract.user_id][contract.company_id].min_hours = contract.min_hours;
                
                if(_.if_empty(formatted_data[contract.user_id][contract.company_id].max_hours, 0) < !_.is_empty(contract.max_hours, 0))
                    formatted_data[contract.user_id][contract.company_id].max_hours = contract.max_hours;
                
                if(_.if_empty(formatted_data[contract.user_id][contract.company_id].day_min_hours, 0) < !_.is_empty(contract.day_min_hours, 0))
                    formatted_data[contract.user_id][contract.company_id].day_min_hours = contract.day_min_hours;
                
                // Als je een nieuw contract krijgt moeten we hem samenvoegen voor deze periode.
                if(_.is_empty(contract.end_date) || contract.end_date > formatted_data[contract.user_id][contract.company_id].end_date)
                    formatted_data[contract.user_id][contract.company_id].end_date = contract.end_date;

                if(contract.period_min_hours)
                    formatted_data[contract.user_id][contract.company_id].period_min_hours = (formatted_data[contract.user_id][contract.company_id].period_min_hours || 0) + contract.period_min_hours;
            }
        }
        
        // Dit doen we achteraf omdat we contracten van hetzelfde bedrijf samenvoegen wanneer je binnen een nieuwe periode een nieuw contract krijgt.
        // Als we het niet achteraf zouden doen zou je door afronding een verkeerd aantal uren te zien krijgen.
        for(let i in formatted_data)
            for(let y in formatted_data[i])
            {
                formatted_data[i][y].active = (formatted_data[i][y].start_date <= settings.period.end_date && (_.is_empty(formatted_data[i][y].end_date) || formatted_data[i][y].end_date >= settings.period.start_date));
                
                if(_.if_empty(formatted_data[i][y].period_min_hours, 0) > 0)
                    formatted_data[i][y].period_min_hours = _.round(formatted_data[i][y].period_min_hours, 2);
            }

        return formatted_data;
    },
    
    get_active_contract(settings) {
        if(_.is_empty(settings.contracts))
            return null;
    
        for(let i in settings.contracts)
        {
            if(!_.is_empty(settings.customer_object_id) && !_.is_empty(settings.contracts[i].customer_object_ids) && !_.is_value_in_set(settings.contracts[i].customer_object_ids, settings.customer_object_id))
                continue;
            
            if(!_.is_empty(settings.function_group_id) && !_.is_empty(settings.contracts[i].function_group_ids) && !_.is_value_in_set(settings.contracts[i].function_group_ids, settings.function_group_id))
                continue;
            
            if(settings.contracts[i].start_date <= settings.date && (_.is_empty(settings.contracts[i].end_date) || settings.contracts[i].end_date >= settings.date))
                return settings.contracts[i];
        }
    
        if(settings.check_if_active_today)
        {
            let today = new CustomDate().getYearMonthDay();
    
            for(let i in settings.contracts)
            {
                if(!_.is_empty(settings.customer_object_id) && !_.is_empty(settings.contracts[i].customer_object_ids) && !_.is_value_in_set(settings.contracts[i].customer_object_ids, settings.customer_object_id))
                    continue;
            
                if(!_.is_empty(settings.function_group_id) && !_.is_empty(settings.contracts[i].function_group_ids) && !_.is_value_in_set(settings.contracts[i].function_group_ids, settings.function_group_id))
                    continue;
                
                if(settings.contracts[i].start_date <= today && (_.is_empty(settings.contracts[i].end_date) || settings.contracts[i].end_date >= today))
                    return settings.contracts[i];
            }
        }
    
        return null;
    },
    
    get_leave(settings) {
        let result      = 0;
        let day_number  = settings.day_number;
        
        if(_.is_empty(day_number))
            day_number = (new CustomDate(settings.date)).getDayNumber();
        
        if(!_.is_empty(settings.contract.day_min_hours))
        {
            let exception;
            
            if(!_.is_empty(settings.leave_application_item.leave_taken_exceptions) && settings.leave_application_item.leave_taken_exceptions[settings.date])
                exception = settings.leave_application_item.leave_taken_exceptions[settings.date];
            
            // In het weekend rekenen we alleen verlof als er een uitzondering is opgegeven.
            if(exception)
                result = exception;
            else if(day_number <= 4)
                result = settings.contract.day_min_hours * 60;
        }
        
        return result;
    }
};

export const Material = {
    format_materials(settings) {
        let models = settings.models;
        
        for (let i in models)
        {
            models[i]['employee_materials'] = settings.employee_materials[models[i].id];
            models[i]['issued_amount']      = 0;
            
            // De hoeveelheid materialen aan medewerkers berekenen.
            for (let a in models[i]['employee_materials']) 
            {
                let employee_material = models[i]['employee_materials'][a];
                
                if (employee_material.employee_material_issue_id)
                    if (settings.material_issues[employee_material.employee_material_issue_id].rejected == 't')
                        continue
                
                if (employee_material.employee_material_intake_id)
                    if (!_.is_empty(settings.material_intakes[employee_material.employee_material_intake_id]))
                        if ((settings.material_intakes[employee_material.employee_material_intake_id].rejected == 't' || _.is_empty(settings.material_intakes[employee_material.employee_material_intake_id].signature)) && settings.material_intakes[employee_material.employee_material_intake_id].in_app != 'f')
                            continue
                
                if (employee_material.employee_material_issue_id)
                    models[i]['issued_amount'] += parseInt(employee_material.amount);
                else if (employee_material.employee_material_intake_id)
                    models[i]['issued_amount'] -= parseInt(employee_material.amount);
                
                if (!_.is_empty(settings.employees) && settings.employees[employee_material.user_id])
                {
                    _.set_object_chain(models[i], { chain: ['employees', employee_material.user_id], value: {...settings.employees[employee_material.user_id], amount: 0}});
                    
                    // Uitgegeven hoeveelheid per medewerker berekenen.
                    if (employee_material.employee_material_issue_id)
                        models[i]['employees'][employee_material.user_id]['amount'] += parseInt(employee_material.amount);
                    else if (employee_material.employee_material_intake_id)
                        models[i]['employees'][employee_material.user_id]['amount'] -= parseInt(employee_material.amount);
                }
            }
            
            models[i]['employees']          = _.values(models[i]['employees']);
            models[i]['employees']          = models[i]['employees'].filter(employee => employee.amount > 0);
            models[i]['object_materials']   = settings.object_materials[models[i].id];
            
            // De hoeveelheid materialen aan objecten berekenen.
            for (let a in models[i]['object_materials']) 
            {
                let object_material = models[i]['object_materials'][a];
                
                if (object_material.object_material_issue_id && settings.object_issues[object_material.object_material_issue_id])
                    if (settings.object_issues[object_material.object_material_issue_id].rejected == "t")
                        continue
                
                if (object_material.object_material_issue_id)
                    models[i]['issued_amount'] += parseInt(object_material.amount);
                else if (object_material.object_material_intake_id)
                    models[i]['issued_amount'] -= parseInt(object_material.amount);
                
                if (!_.is_empty(settings.objects) && settings.objects[object_material.customer_object_id])
                {
                    _.set_object_chain(models[i], { chain: ['objects', object_material.customer_object_id], value: {...settings.objects[object_material.customer_object_id], amount: 0}});
                    
                    // Uitgegeven hoeveelheid per object berekenen.
                    if (object_material.object_material_issue_id)
                        models[i]['objects'][object_material.customer_object_id]['amount'] += parseInt(object_material.amount);
                    else if (object_material.object_material_intake_id)
                        models[i]['objects'][object_material.customer_object_id]['amount'] -= parseInt(object_material.amount);
                }
            }
            
            models[i]['objects']    = _.values(models[i]['objects']);
            models[i]['objects']    = models[i]['objects'].filter(object => object.amount > 0);
            let supply              = 0;
            
            // Als er maar 1 model wordt aangeleverd en het is niet de overview dan horen de geleverde restocks en writeoffs alleen maar van die model te zijn.
            if (models.length == 1 && settings.overview != true) {
                for (let j in settings.restocks)
                    supply += parseInt(settings.restocks[j].amount);
                
                for (let k in settings.writeoffs)
                    supply -= parseInt(settings.writeoffs[k].amount);
                
                models[i]['supply'] = supply;
            }
            else {
                for (let j in settings.restocks[models[i].id])
                    supply += parseInt(settings.restocks[models[i].id][j].amount);
                
                for (let k in settings.writeoffs[models[i].id])
                    supply -= parseInt(settings.writeoffs[models[i].id][k].amount);
                
                models[i]['supply'] = supply;
            }
        }
        
        return models;
    },
    
    format_remaining_materials(settings) {
        const materials                     = {};
        const already_writted_off_materials = [];
        
        settings.models.forEach(model => {
            const key = model.material_id + '-' + model.particularities;
            
            if (_.is_empty(settings.material_types[model.material_id]))
                return;
                
            // De data formaten voor de employee intake.
            if(!_.is_empty(settings.employee_material_issues)) {
                if (settings.material_types[model.material_id].archived == 't')
                    return;
                    
                if (model.employee_material_issue_id && settings.employee_material_issues[model.employee_material_issue_id]) {
                    const issue = settings.employee_material_issues[model.employee_material_issue_id];
                    
                    if (((issue.rejected == 't' || _.is_empty(issue.signature))) && issue.in_app != 'f')
                        return;
                }
                
                if (model.employee_material_intake_id && settings.employee_material_intakes[model.employee_material_intake_id]) {
                    const intake = settings.employee_material_intakes[model.employee_material_intake_id];
                    
                    if (((intake.rejected == 't' || _.is_empty(intake.signature))) && intake.in_app != 'f')
                        return;
                }
                
                _.set_object_chain(materials, { chain: [key], value: { ...model, title: settings.material_types[model.material_id].title, amount: 0 } });
                
            	if (model.employee_material_issue_id)
            		materials[key].amount += parseInt(model.amount);
            	else if (model.employee_material_intake_id)
            		materials[key].amount -= parseInt(model.amount);
            		
            	if(_.is_empty(settings.material_write_offs) || _.is_empty(settings.material_write_offs[model.material_id]) || already_writted_off_materials.includes(model.material_id))
            	    return;
            	    
        	    _.each(settings.material_write_offs[model.material_id], write_off => {
        	        materials[key].amount -= parseInt(write_off.amount);
        	    });
        	    
        	    already_writted_off_materials.push(model.material_id);
            } else if(!_.is_empty(settings.object_material_issues)) {
                if (settings.material_types[model.material_id].archived == 't')
                    return;
                    
                if (model.object_material_issue_id && settings.object_material_issues[model.object_material_issue_id]) {
                    const issue = settings.object_material_issues[model.object_material_issue_id];
                    
                    if (issue.rejected == 't' || _.is_empty(issue.signature) || _.is_empty(issue.delivered_signature))
                        return;
                }
                
                _.set_object_chain(materials, { chain: [key], value: {...model, title: settings.material_types[model.material_id].title, amount: 0} });
                
                if (model.object_material_issue_id) 
                    materials[key].amount += parseInt(model.amount);
                else
                    materials[key].amount -= parseInt(model.amount);
            }
        });
        
        if(settings.keep_keys)
            return materials;
        
        return _.values(materials);
    }
}